export const PAGE_TYPE = Object.freeze({
  HOME_PAGE: "home-page",
  SECTION_PAGE: "section-page",
  COLLECTION_PAGE: "collection-page",
  TAG_PAGE: "tag-page",
  NOTIFICATION_PAGE: "notification-page",
  SEARCH_PAGE: "search-page",
  SAVED_PAGE: "saved-page",
  STORY_PAGE: "story-page",
  STORY_PUBLIC_PREVIEW_PAGE: "story-public-preview-page",
  STORY_PREVIEW: "story-preview",
  HOME_PREVIEW: "home-preview",
  STATIC_PAGE: "static-page",
  AUTHOR_PAGE: "author-page",
  FORGOT_PASSWORD_PAGE: "forgot-password-page",
  RESET_PASSWORD_PAGE: "reset-password-page",
  CHANGE_PASSWORD_PAGE: "change-password-page",
  PROFILE_PAGE: "profile-page",
  EDIT_PROFILE_PAGE: "edit-profile-page",
  COMMENTS_PAGE: "my-comments",
  USER_NEWSLETTERS_PAGE: "user-newsletters-page",
  NEWSLETTERS_PAGE: "newsletters-page",
  LOGIN_PAGE: "sign-in-page",
  SIGNUP_PAGE: "sign-up-page",
  VERIFY_EMAIL_PAGE: "verify-email-page"
});

export const TAG_PAGE_URL_PREFIX = "/topic/";

export const FALLBACK_PUBLISHER_CONFIG = Object.freeze({
  lang: "bn",
  push_engage_api_key: "wd14R3g4x53YyuGeK1PIsqbQv17E5VCA",
  bangla_sketches_host: "https://prothomalo-web.qtstage.io",
  english_sketches_host: "https://prothomalo-english-web.qtstage.io",
  metypeConfig: {
    metypeHost: "https://staging.metype.com",
    metypeAccountId: "1001903",
    primaryColor: "#000",
    secondaryColor: "#f2f2f2",
    className: "story-comments-widget",
    publisher: "Prothomalo"
  },
  primaryColor: "#8f0f01",
  secondaryColor: "#f2f2f2",
  className: "story-comments-widget",
  publisher: "prothomalo",
  env: "staging",
  google_tag_manager: {
    id: "GTM-M2JPDF4"
  },
  google_analytics: {
    id: "UA-155251086-1"
  },
  socialAuth: {
    google: "568104192219-qbkqku481s02lt0pm3nphhq8c5brglom.apps.googleusercontent.com",
    fb: "598209867633389"
  }
});

export const TOPICS_FILTER = [
  {
    name: "ঢাকা",
    "external-id": "87",
    "parent-external-id": null,
    slug: "ঢাকা"
  },
  {
    name: "চট্ট্রগ্রাম",
    "external-id": "1698",
    "parent-external-id": null,
    slug: "চট্ট্রগ্রাম"
  },
  {
    name: "সিলেট",
    "external-id": "1684",
    "parent-external-id": null,
    slug: "সিলেট"
  },
  {
    name: "বরিশাল",
    "external-id": "1688",
    "parent-external-id": null,
    slug: "বরিশাল"
  },
  {
    name: "রাজশাহী",
    "external-id": "1692",
    "parent-external-id": null,
    slug: "রাজশাহী"
  },
  {
    name: "খুলনা",
    "external-id": "1690",
    "parent-external-id": null,
    slug: "খুলনা"
  },
  {
    name: "রংপুর",
    "external-id": "1682",
    "parent-external-id": null,
    slug: "রংপুর"
  },
  {
    name: "ঢাকা",
    "external-id": "1148",
    "parent-external-id": "87",
    slug: "ঢাকা"
  },
  {
    name: "নরসিংদী",
    "external-id": "386",
    "parent-external-id": "87",
    slug: "নরসিংদী"
  },
  {
    name: "নারায়ণগঞ্জ",
    "external-id": "247",
    "parent-external-id": "87",
    slug: "নারায়ণগঞ্জ"
  },
  {
    name: "গাজীপুর",
    "external-id": "245",
    "parent-external-id": "87",
    slug: "গাজীপুর"
  },
  {
    name: "মুন্সিগঞ্জ",
    "external-id": "385",
    "parent-external-id": "87",
    slug: "মুন্সিগঞ্জ"
  },
  {
    name: "মানিকগঞ্জ",
    "external-id": "374",
    "parent-external-id": "87",
    slug: "মানিকগঞ্জ"
  },
  {
    name: "টাঙ্গাইল",
    "external-id": "329",
    "parent-external-id": "87",
    slug: "টাঙ্গাইল"
  },
  {
    name: "ময়মনসিংহ",
    "external-id": "256",
    "parent-external-id": "87",
    slug: "ময়মনসিংহ"
  },
  {
    name: "রাজবাড়ী",
    "external-id": "368",
    "parent-external-id": "87",
    slug: "রাজবাড়ী"
  },
  {
    name: "শেরপুর",
    "external-id": "278",
    "parent-external-id": "87",
    slug: "শেরপুর"
  },
  {
    name: "গোপালগঞ্জ",
    "external-id": "314",
    "parent-external-id": "87",
    slug: "গোপালগঞ্জ"
  },
  {
    name: "জামালপুর",
    "external-id": "530",
    "parent-external-id": "87",
    slug: "জামালপুর"
  },
  {
    name: "শরীয়তপুর",
    "external-id": "410",
    "parent-external-id": "87",
    slug: "শরীয়তপুর"
  },
  {
    name: "নেত্রকোনা",
    "external-id": "253",
    "parent-external-id": "87",
    slug: "নেত্রকোনা"
  },
  {
    name: "মাদারীপুর",
    "external-id": "311",
    "parent-external-id": "87",
    slug: "মাদারীপুর"
  },
  {
    name: "ফরিদপুর",
    "external-id": "315",
    "parent-external-id": "87",
    slug: "ফরিদপুর"
  },
  {
    name: "কিশোরগঞ্জ",
    "external-id": "250",
    "parent-external-id": "87",
    slug: "কিশোরগঞ্জ"
  },
  {
    name: "চট্টগ্রাম",
    "external-id": "55",
    "parent-external-id": "1698",
    slug: "চট্টগ্রাম"
  },
  {
    name: "চাঁদপুর",
    "external-id": "243",
    "parent-external-id": "1698",
    slug: "চাঁদপুর"
  },
  {
    name: "কুমিল্লা",
    "external-id": "144",
    "parent-external-id": "1698",
    slug: "কুমিল্লা"
  },
  {
    name: "কক্সবাজার",
    "external-id": "264",
    "parent-external-id": "1698",
    slug: "কক্সবাজার"
  },
  {
    name: "বান্দরবান",
    "external-id": "376",
    "parent-external-id": "1698",
    slug: "বান্দরবান"
  },
  {
    name: "খাগড়াছড়ি",
    "external-id": "337",
    "parent-external-id": "1698",
    slug: "খাগড়াছড়ি"
  },
  {
    name: "রাঙামাটি",
    "external-id": "262",
    "parent-external-id": "1698",
    slug: "রাঙামাটি"
  },
  {
    name: "নোয়াখালী",
    "external-id": "266",
    "parent-external-id": "1698",
    slug: "নোয়াখালী"
  },
  {
    name: "লক্ষ্মীপুর",
    "external-id": "441",
    "parent-external-id": "1698",
    slug: "লক্ষ্মীপুর"
  },
  {
    name: "ফেনী",
    "external-id": "333",
    "parent-external-id": "1698",
    slug: "ফেনী"
  },
  {
    name: "ব্রাহ্মণবাড়িয়া",
    "external-id": "328",
    "parent-external-id": "1698",
    slug: "ব্রাহ্মণবাড়িয়া"
  },
  {
    name: "সিলেট",
    "external-id": "88",
    "parent-external-id": "1684",
    slug: "সিলেট"
  },
  {
    name: "হবিগঞ্জ",
    "external-id": "260",
    "parent-external-id": "1684",
    slug: "হবিগঞ্জ"
  },
  {
    name: "মৌলভীবাজার",
    "external-id": "244",
    "parent-external-id": "1684",
    slug: "মৌলভীবাজার"
  },
  {
    name: "সুনামগঞ্জ",
    "external-id": "252",
    "parent-external-id": "1684",
    slug: "সুনামগঞ্জ"
  },
  {
    name: "বরিশাল",
    "external-id": "92",
    "parent-external-id": "1688",
    slug: "বরিশাল"
  },
  {
    name: "বরগুনা",
    "external-id": "275",
    "parent-external-id": "1688",
    slug: "বরগুনা"
  },
  {
    name: "ভোলা",
    "external-id": "324",
    "parent-external-id": "1688",
    slug: "ভোলা"
  },
  {
    name: "ঝালকাঠি",
    "external-id": "339",
    "parent-external-id": "1688",
    slug: "ঝালকাঠি"
  },
  {
    name: "পটুয়াখালী",
    "external-id": "355",
    "parent-external-id": "1688",
    slug: "পটুয়াখালী"
  },
  {
    name: "পিরোজপুর",
    "external-id": "307",
    "parent-external-id": "1688",
    slug: "পিরোজপুর"
  },
  {
    name: "রাজশাহী",
    "external-id": "50",
    "parent-external-id": "1692",
    slug: "রাজশাহী"
  },
  {
    name: "নাটোর",
    "external-id": "487",
    "parent-external-id": "1692",
    slug: "নাটোর"
  },
  {
    name: "চাঁপাইনবাবগঞ্জ",
    "external-id": "343",
    "parent-external-id": "1692",
    slug: "চাঁপাইনবাবগঞ্জ"
  },
  {
    name: "জয়পুরহাট",
    "external-id": "1652",
    "parent-external-id": "1692",
    slug: "জয়পুরহাট"
  },
  {
    name: "নওগাঁ",
    "external-id": "280",
    "parent-external-id": "1692",
    slug: "নওগাঁ"
  },
  {
    name: "বগুড়া",
    "external-id": "277",
    "parent-external-id": "1692",
    slug: "বগুড়া"
  },
  {
    name: "পাবনা",
    "external-id": "320",
    "parent-external-id": "1692",
    slug: "পাবনা"
  },
  {
    name: "সিরাজগঞ্জ",
    "external-id": "281",
    "parent-external-id": "1692",
    slug: "সিরাজগঞ্জ"
  },
  {
    name: "খুলনা",
    "external-id": "90",
    "parent-external-id": "1690",
    slug: "খুলনা"
  },
  {
    name: "বাগেরহাট",
    "external-id": "285",
    "parent-external-id": "1690",
    slug: "বাগেরহাট"
  },
  {
    name: "চুয়াডাঙ্গা",
    "external-id": "364",
    "parent-external-id": "1690",
    slug: "চুয়াডাঙ্গা"
  },
  {
    name: "যশোর",
    "external-id": "241",
    "parent-external-id": "1690",
    slug: "যশোর"
  },
  {
    name: "ঝিনাইদহ",
    "external-id": "312",
    "parent-external-id": "1690",
    slug: "ঝিনাইদহ"
  },
  {
    name: "কুষ্টিয়া",
    "external-id": "272",
    "parent-external-id": "1690",
    slug: "কুষ্টিয়া"
  },
  {
    name: "মাগুরা",
    "external-id": "463",
    "parent-external-id": "1690",
    slug: "মাগুরা"
  },
  {
    name: "মেহেরপুর",
    "external-id": "269",
    "parent-external-id": "1690",
    slug: "মেহেরপুর"
  },
  {
    name: "নড়াইল",
    "external-id": "248",
    "parent-external-id": "1690",
    slug: "নড়াইল"
  },
  {
    name: "সাতক্ষীরা",
    "external-id": "274",
    "parent-external-id": "1690",
    slug: "সাতক্ষীরা"
  },
  {
    name: "রংপুর",
    "external-id": "47",
    "parent-external-id": "1682",
    slug: "রংপুর"
  },
  {
    name: "দিনাজপুর",
    "external-id": "282",
    "parent-external-id": "1682",
    slug: "দিনাজপুর"
  },
  {
    name: "গাইবান্ধা",
    "external-id": "322",
    "parent-external-id": "1682",
    slug: "গাইবান্ধা"
  },
  {
    name: "কুড়িগ্রাম",
    "external-id": "301",
    "parent-external-id": "1682",
    slug: "কুড়িগ্রাম"
  },
  {
    name: "নীলফামারী",
    "external-id": "283",
    "parent-external-id": "1682",
    slug: "নীলফামারী"
  },
  {
    name: "পঞ্চগড়",
    "external-id": "483",
    "parent-external-id": "1682",
    slug: "পঞ্চগড়"
  },
  {
    name: "ঠাকুরগাঁও",
    "external-id": "299",
    "parent-external-id": "1682",
    slug: "ঠাকুরগাঁও"
  },
  {
    name: "লালমনিরহাট",
    "external-id": "356",
    "parent-external-id": "1682",
    slug: "লালমনিরহাট"
  },
  {
    name: "রাজধানী ঢাকা",
    "external-id": "296",
    "parent-external-id": "1148",
    slug: "রাজধানী-ঢাকা"
  },
  {
    name: "ধামরাই",
    "external-id": "1150",
    "parent-external-id": "1148",
    slug: "ধামরাই"
  },
  {
    name: "দোহার",
    "external-id": "437",
    "parent-external-id": "1148",
    slug: "দোহার"
  },
  {
    name: "কেরানীগঞ্জ",
    "external-id": "378",
    "parent-external-id": "1148",
    slug: "কেরানীগঞ্জ"
  },
  {
    name: "নবাবগঞ্জ",
    "external-id": "438",
    "parent-external-id": "1148",
    slug: "নবাবগঞ্জ"
  },
  {
    name: "সাভার",
    "external-id": "332",
    "parent-external-id": "1148",
    slug: "সাভার"
  },
  {
    name: "বেলাবো",
    "external-id": "1152",
    "parent-external-id": "386",
    slug: "বেলাবো"
  },
  {
    name: "মনোহরদী",
    "external-id": "1154",
    "parent-external-id": "386",
    slug: "মনোহরদী"
  },
  {
    name: "শিবপুর",
    "external-id": "1156",
    "parent-external-id": "386",
    slug: "শিবপুর"
  },
  {
    name: "রায়পুরা",
    "external-id": "1158",
    "parent-external-id": "386",
    slug: "রায়পুরা"
  },
  {
    name: "পলাশ",
    "external-id": "767",
    "parent-external-id": "386",
    slug: "পলাশ"
  },
  {
    name: "নরসিংদী সদর",
    "external-id": "1160",
    "parent-external-id": "386",
    slug: "নরসিংদী-সদর"
  },
  {
    name: "নারায়ণগঞ্জ সিটি",
    "external-id": "1098",
    "parent-external-id": "247",
    slug: "নারায়ণগঞ্জ-সিটি"
  },
  {
    name: "নারায়ণগঞ্জ সদর",
    "external-id": "1178",
    "parent-external-id": "247",
    slug: "নারায়ণগঞ্জ-সদর"
  },
  {
    name: "বন্দর",
    "external-id": "1180",
    "parent-external-id": "247",
    slug: "বন্দর"
  },
  {
    name: "আড়াইহাজার",
    "external-id": "1184",
    "parent-external-id": "247",
    slug: "আড়াইহাজার"
  },
  {
    name: "রূপগঞ্জ",
    "external-id": "1188",
    "parent-external-id": "247",
    slug: "রূপগঞ্জ"
  },
  {
    name: "সোনারগাঁ",
    "external-id": "246",
    "parent-external-id": "247",
    slug: "সোনারগাঁ"
  },
  {
    name: "গাজীপুর সিটি",
    "external-id": "1028",
    "parent-external-id": "245",
    slug: "গাজীপুর-সিটি"
  },
  {
    name: "গাজীপুর সদর",
    "external-id": "1200",
    "parent-external-id": "245",
    slug: "গাজীপুর-সদর"
  },
  {
    name: "কালিয়াকৈর",
    "external-id": "1202",
    "parent-external-id": "245",
    slug: "কালিয়াকৈর"
  },
  {
    name: "কালীগঞ্জ",
    "external-id": "370",
    "parent-external-id": "245",
    slug: "কালীগঞ্জ"
  },
  {
    name: "কাপাসিয়া",
    "external-id": "795",
    "parent-external-id": "245",
    slug: "কাপাসিয়া"
  },
  {
    name: "শ্রীপুর",
    "external-id": "1204",
    "parent-external-id": "245",
    slug: "শ্রীপুর"
  },
  {
    name: "শ্রীনগর",
    "external-id": "1206",
    "parent-external-id": "385",
    slug: "শ্রীনগর"
  },
  {
    name: "সিরাজদীখান",
    "external-id": "1208",
    "parent-external-id": "385",
    slug: "সিরাজদীখান"
  },
  {
    name: "লৌহজং",
    "external-id": "1210",
    "parent-external-id": "385",
    slug: "লৌহজং"
  },
  {
    name: "টঙ্গিবাড়ী",
    "external-id": "978",
    "parent-external-id": "385",
    slug: "টঙ্গিবাড়ী"
  },
  {
    name: "মুন্সিগঞ্জ সদর",
    "external-id": "1212",
    "parent-external-id": "385",
    slug: "মুন্সিগঞ্জ-সদর"
  },
  {
    name: "গজারিয়া",
    "external-id": "384",
    "parent-external-id": "385",
    slug: "গজারিয়া"
  },
  {
    name: "মানিকগঞ্জ সদর",
    "external-id": "1214",
    "parent-external-id": "374",
    slug: "মানিকগঞ্জ-সদর"
  },
  {
    name: "সিঙ্গাইর",
    "external-id": "1216",
    "parent-external-id": "374",
    slug: "সিঙ্গাইর"
  },
  {
    name: "শিবালয়",
    "external-id": "1218",
    "parent-external-id": "374",
    slug: "শিবালয়"
  },
  {
    name: "সাটুরিয়া",
    "external-id": "870",
    "parent-external-id": "374",
    slug: "সাটুরিয়া"
  },
  {
    name: "হরিরামপুর",
    "external-id": "940",
    "parent-external-id": "374",
    slug: "হরিরামপুর"
  },
  {
    name: "ঘিওর",
    "external-id": "1220",
    "parent-external-id": "374",
    slug: "ঘিওর"
  },
  {
    name: "দৌলতপুর",
    "external-id": "675",
    "parent-external-id": "374",
    slug: "দৌলতপুর"
  },
  {
    name: "টাঙ্গাইল সদর",
    "external-id": "1222",
    "parent-external-id": "329",
    slug: "টাঙ্গাইল-সদর"
  },
  {
    name: "কালিহাতী",
    "external-id": "687",
    "parent-external-id": "329",
    slug: "কালিহাতী"
  },
  {
    name: "ঘাটাইল",
    "external-id": "414",
    "parent-external-id": "329",
    slug: "ঘাটাইল"
  },
  {
    name: "বাসাইল",
    "external-id": "1224",
    "parent-external-id": "329",
    slug: "বাসাইল"
  },
  {
    name: "গোপালপুর",
    "external-id": "1226",
    "parent-external-id": "329",
    slug: "গোপালপুর"
  },
  {
    name: "মির্জাপুর",
    "external-id": "330",
    "parent-external-id": "329",
    slug: "মির্জাপুর"
  },
  {
    name: "ভূঞাপুর",
    "external-id": "1228",
    "parent-external-id": "329",
    slug: "ভূঞাপুর"
  },
  {
    name: "নাগরপুর",
    "external-id": "1230",
    "parent-external-id": "329",
    slug: "নাগরপুর"
  },
  {
    name: "মধুপুর",
    "external-id": "1232",
    "parent-external-id": "329",
    slug: "মধুপুর"
  },
  {
    name: "সখিপুর",
    "external-id": "1234",
    "parent-external-id": "329",
    slug: "সখিপুর"
  },
  {
    name: "দেলদুয়ার",
    "external-id": "1236",
    "parent-external-id": "329",
    slug: "দেলদুয়ার"
  },
  {
    name: "ধনবাড়ী",
    "external-id": "1238",
    "parent-external-id": "329",
    slug: "ধনবাড়ী"
  },
  {
    name: "ময়মনসিংহ সদর",
    "external-id": "1508",
    "parent-external-id": "256",
    slug: "ময়মনসিংহ-সদর"
  },
  {
    name: "ত্রিশাল",
    "external-id": "267",
    "parent-external-id": "256",
    slug: "ত্রিশাল"
  },
  {
    name: "গৌরীপুর",
    "external-id": "637",
    "parent-external-id": "256",
    slug: "গৌরীপুর"
  },
  {
    name: "মুক্তাগাছা",
    "external-id": "1518",
    "parent-external-id": "256",
    slug: "মুক্তাগাছা"
  },
  {
    name: "ফুলপুর",
    "external-id": "479",
    "parent-external-id": "256",
    slug: "ফুলপুর"
  },
  {
    name: "হালুয়াঘাট",
    "external-id": "1524",
    "parent-external-id": "256",
    slug: "হালুয়াঘাট"
  },
  {
    name: "ভালুকা",
    "external-id": "610",
    "parent-external-id": "256",
    slug: "ভালুকা"
  },
  {
    name: "ফুলবাড়িয়া",
    "external-id": "1528",
    "parent-external-id": "256",
    slug: "ফুলবাড়িয়া"
  },
  {
    name: "গফরগাঁও",
    "external-id": "1110",
    "parent-external-id": "256",
    slug: "গফরগাঁও"
  },
  {
    name: "ঈশ্বরগঞ্জ",
    "external-id": "255",
    "parent-external-id": "256",
    slug: "ঈশ্বরগঞ্জ"
  },
  {
    name: "নান্দাইল",
    "external-id": "257",
    "parent-external-id": "256",
    slug: "নান্দাইল"
  },
  {
    name: "ধোবাউড়া",
    "external-id": "1534",
    "parent-external-id": "256",
    slug: "ধোবাউড়া"
  },
  {
    name: "রাজবাড়ী সদর",
    "external-id": "1538",
    "parent-external-id": "368",
    slug: "রাজবাড়ী-সদর"
  },
  {
    name: "গোয়ালন্দ",
    "external-id": "367",
    "parent-external-id": "368",
    slug: "গোয়ালন্দ"
  },
  {
    name: "পাংশা",
    "external-id": "801",
    "parent-external-id": "368",
    slug: "পাংশা"
  },
  {
    name: "বালিয়াকান্দি",
    "external-id": "800",
    "parent-external-id": "368",
    slug: "বালিয়াকান্দি"
  },
  {
    name: "ঝিনাইগাতি",
    "external-id": "1542",
    "parent-external-id": "278",
    slug: "ঝিনাইগাতি"
  },
  {
    name: "নকলা",
    "external-id": "1546",
    "parent-external-id": "278",
    slug: "নকলা"
  },
  {
    name: "নালিতাবাড়ি",
    "external-id": "1548",
    "parent-external-id": "278",
    slug: "নালিতাবাড়ি"
  },
  {
    name: "শেরপুর সদর",
    "external-id": "1550",
    "parent-external-id": "278",
    slug: "শেরপুর-সদর"
  },
  {
    name: "শ্রীবর্দি",
    "external-id": "1552",
    "parent-external-id": "278",
    slug: "শ্রীবর্দি"
  },
  {
    name: "গোপালগঞ্জ সদর",
    "external-id": "1558",
    "parent-external-id": "314",
    slug: "গোপালগঞ্জ-সদর"
  },
  {
    name: "মুকসুদপুর",
    "external-id": "1560",
    "parent-external-id": "314",
    slug: "মুকসুদপুর"
  },
  {
    name: "কাশিয়ানী",
    "external-id": "1564",
    "parent-external-id": "314",
    slug: "কাশিয়ানী"
  },
  {
    name: "কোটালীপাড়া",
    "external-id": "1566",
    "parent-external-id": "314",
    slug: "কোটালীপাড়া"
  },
  {
    name: "টুঙ্গিপাড়া",
    "external-id": "1568",
    "parent-external-id": "314",
    slug: "টুঙ্গিপাড়া"
  },
  {
    name: "জামালপুর সদর",
    "external-id": "1572",
    "parent-external-id": "530",
    slug: "জামালপুর-সদর"
  },
  {
    name: "বকশীগঞ্জ",
    "external-id": "1574",
    "parent-external-id": "530",
    slug: "বকশীগঞ্জ"
  },
  {
    name: "দেওয়ানগঞ্জ",
    "external-id": "1576",
    "parent-external-id": "530",
    slug: "দেওয়ানগঞ্জ"
  },
  {
    name: "ইসলামপুর",
    "external-id": "1578",
    "parent-external-id": "530",
    slug: "ইসলামপুর"
  },
  {
    name: "মাদারগঞ্জ",
    "external-id": "553",
    "parent-external-id": "530",
    slug: "মাদারগঞ্জ"
  },
  {
    name: "মেলান্দহ",
    "external-id": "1580",
    "parent-external-id": "530",
    slug: "মেলান্দহ"
  },
  {
    name: "সরিষাবাড়ী",
    "external-id": "529",
    "parent-external-id": "530",
    slug: "সরিষাবাড়ী"
  },
  {
    name: "শরীয়তপুর সদর",
    "external-id": "1582",
    "parent-external-id": "410",
    slug: "শরীয়তপুর-সদর"
  },
  {
    name: "ডামুড্যা",
    "external-id": "1584",
    "parent-external-id": "410",
    slug: "ডামুড্যা"
  },
  {
    name: "নড়িয়া",
    "external-id": "1586",
    "parent-external-id": "410",
    slug: "নড়িয়া"
  },
  {
    name: "ভেদরগঞ্জ",
    "external-id": "1590",
    "parent-external-id": "410",
    slug: "ভেদরগঞ্জ"
  },
  {
    name: "জানজিরা",
    "external-id": "1592",
    "parent-external-id": "410",
    slug: "জানজিরা"
  },
  {
    name: "গোসাইরহাট",
    "external-id": "1594",
    "parent-external-id": "410",
    slug: "গোসাইরহাট"
  },
  {
    name: "নেত্রকোনা সদর",
    "external-id": "1614",
    "parent-external-id": "253",
    slug: "নেত্রকোনা-সদর"
  },
  {
    name: "পূর্বধলা",
    "external-id": "780",
    "parent-external-id": "253",
    slug: "পূর্বধলা"
  },
  {
    name: "আটপাড়া",
    "external-id": "1596",
    "parent-external-id": "253",
    slug: "আটপাড়া"
  },
  {
    name: "বারহাট্টা",
    "external-id": "1598",
    "parent-external-id": "253",
    slug: "বারহাট্টা"
  },
  {
    name: "দুর্গাপুর",
    "external-id": "1602",
    "parent-external-id": "253",
    slug: "দুর্গাপুর"
  },
  {
    name: "খালিয়াজুড়ি",
    "external-id": "1604",
    "parent-external-id": "253",
    slug: "খালিয়াজুড়ি"
  },
  {
    name: "কলমাকান্দা",
    "external-id": "1606",
    "parent-external-id": "253",
    slug: "কলমাকান্দা"
  },
  {
    name: "কেন্দুয়া",
    "external-id": "254",
    "parent-external-id": "253",
    slug: "কেন্দুয়া"
  },
  {
    name: "মদন",
    "external-id": "1608",
    "parent-external-id": "253",
    slug: "মদন"
  },
  {
    name: "মোহনগঞ্জ",
    "external-id": "509",
    "parent-external-id": "253",
    slug: "মোহনগঞ্জ"
  },
  {
    name: "মাদারীপুর সদর",
    "external-id": "1616",
    "parent-external-id": "311",
    slug: "মাদারীপুর-সদর"
  },
  {
    name: "শিবচর",
    "external-id": "711",
    "parent-external-id": "311",
    slug: "শিবচর"
  },
  {
    name: "কালকিনী",
    "external-id": "1618",
    "parent-external-id": "311",
    slug: "কালকিনী"
  },
  {
    name: "রাজৈর",
    "external-id": "1620",
    "parent-external-id": "311",
    slug: "রাজৈর"
  },
  {
    name: "ফরিদপুর সদর",
    "external-id": "1622",
    "parent-external-id": "315",
    slug: "ফরিদপুর-সদর"
  },
  {
    name: "বোয়ালমারী",
    "external-id": "1624",
    "parent-external-id": "315",
    slug: "বোয়ালমারী"
  },
  {
    name: "আলফাডাঙা",
    "external-id": "1626",
    "parent-external-id": "315",
    slug: "আলফাডাঙা"
  },
  {
    name: "মধুখালী",
    "external-id": "369",
    "parent-external-id": "315",
    slug: "মধুখালী"
  },
  {
    name: "ভাঙ্গা",
    "external-id": "866",
    "parent-external-id": "315",
    slug: "ভাঙ্গা"
  },
  {
    name: "নগরকান্দা",
    "external-id": "583",
    "parent-external-id": "315",
    slug: "নগরকান্দা"
  },
  {
    name: "চর ভদ্রাসন",
    "external-id": "1628",
    "parent-external-id": "315",
    slug: "চর-ভদ্রাসন"
  },
  {
    name: "সদরপুর",
    "external-id": "1630",
    "parent-external-id": "315",
    slug: "সদরপুর"
  },
  {
    name: "সালথা",
    "external-id": "1632",
    "parent-external-id": "315",
    slug: "সালথা"
  },
  {
    name: "কিশোরগঞ্জ সদর",
    "external-id": "1634",
    "parent-external-id": "250",
    slug: "কিশোরগঞ্জ-সদর"
  },
  {
    name: "অষ্টগ্রাম",
    "external-id": "1636",
    "parent-external-id": "250",
    slug: "অষ্টগ্রাম"
  },
  {
    name: "ইটনা",
    "external-id": "1638",
    "parent-external-id": "250",
    slug: "ইটনা"
  },
  {
    name: "করিমগঞ্জ",
    "external-id": "1640",
    "parent-external-id": "250",
    slug: "করিমগঞ্জ"
  },
  {
    name: "কটিয়াদি",
    "external-id": "1642",
    "parent-external-id": "250",
    slug: "কটিয়াদি"
  },
  {
    name: "কুলিয়ারচর",
    "external-id": "1644",
    "parent-external-id": "250",
    slug: "কুলিয়ারচর"
  },
  {
    name: "তাড়াইল",
    "external-id": "249",
    "parent-external-id": "250",
    slug: "তাড়াইল"
  },
  {
    name: "নিকলী",
    "external-id": "380",
    "parent-external-id": "250",
    slug: "নিকলী"
  },
  {
    name: "পাকুন্দিয়া",
    "external-id": "1646",
    "parent-external-id": "250",
    slug: "পাকুন্দিয়া"
  },
  {
    name: "বাজিতপুর",
    "external-id": "1648",
    "parent-external-id": "250",
    slug: "বাজিতপুর"
  },
  {
    name: "ভৈরব",
    "external-id": "268",
    "parent-external-id": "250",
    slug: "ভৈরব"
  },
  {
    name: "মিটামইন",
    "external-id": "1650",
    "parent-external-id": "250",
    slug: "মিটামইন"
  },
  {
    name: "হোসেনপুর",
    "external-id": "690",
    "parent-external-id": "250",
    slug: "হোসেনপুর"
  },
  {
    name: "আনোয়ারা",
    "external-id": "799",
    "parent-external-id": "55",
    slug: "আনোয়ারা"
  },
  {
    name: "বাঁশখালী",
    "external-id": "1700",
    "parent-external-id": "55",
    slug: "বাঁশখালী"
  },
  {
    name: "বোয়ালখালী",
    "external-id": "1702",
    "parent-external-id": "55",
    slug: "বোয়ালখালী"
  },
  {
    name: "চান্দনাইশ",
    "external-id": "1704",
    "parent-external-id": "55",
    slug: "চান্দনাইশ"
  },
  {
    name: "ফটিকছড়ি",
    "external-id": "342",
    "parent-external-id": "55",
    slug: "ফটিকছড়ি"
  },
  {
    name: "ভূজপূর থানা",
    "external-id": "1706",
    "parent-external-id": "55",
    slug: "ভূজপূর-থানা"
  },
  {
    name: "হাটহাজারী",
    "external-id": "326",
    "parent-external-id": "55",
    slug: "হাটহাজারী"
  },
  {
    name: "লোহাগড়া",
    "external-id": "318",
    "parent-external-id": "55",
    slug: "লোহাগড়া"
  },
  {
    name: "মিরসরাই",
    "external-id": "261",
    "parent-external-id": "55",
    slug: "মিরসরাই"
  },
  {
    name: "পটিয়া",
    "external-id": "531",
    "parent-external-id": "55",
    slug: "পটিয়া"
  },
  {
    name: "রাঙ্গুনিয়া",
    "external-id": "383",
    "parent-external-id": "55",
    slug: "রাঙ্গুনিয়া"
  },
  {
    name: "রাউজান",
    "external-id": "1708",
    "parent-external-id": "55",
    slug: "রাউজান"
  },
  {
    name: "সন্দ্বীপ",
    "external-id": "1710",
    "parent-external-id": "55",
    slug: "সন্দ্বীপ"
  },
  {
    name: "সাতকানিয়া",
    "external-id": "439",
    "parent-external-id": "55",
    slug: "সাতকানিয়া"
  },
  {
    name: "সীতাকুণ্ড",
    "external-id": "336",
    "parent-external-id": "55",
    slug: "সীতাকুণ্ড"
  },
  {
    name: "কর্ণফুলী থানা",
    "external-id": "1712",
    "parent-external-id": "55",
    slug: "কর্ণফুলী-থানা"
  },
  {
    name: "চাঁদপুর সদর",
    "external-id": "1800",
    "parent-external-id": "243",
    slug: "চাঁদপুর-সদর"
  },
  {
    name: "কচুয়া",
    "external-id": "1802",
    "parent-external-id": "243",
    slug: "কচুয়া"
  },
  {
    name: "হাজীগঞ্জ",
    "external-id": "674",
    "parent-external-id": "243",
    slug: "হাজীগঞ্জ"
  },
  {
    name: "শাহরাস্তি",
    "external-id": "1810",
    "parent-external-id": "243",
    slug: "শাহরাস্তি"
  },
  {
    name: "ফরিদগঞ্জ",
    "external-id": "1804",
    "parent-external-id": "243",
    slug: "ফরিদগঞ্জ"
  },
  {
    name: "ফরিদগঞ্জ",
    "external-id": "1806",
    "parent-external-id": "243",
    slug: "ফরিদগঞ্জ"
  },
  {
    name: "মতলব দক্ষিণ",
    "external-id": "319",
    "parent-external-id": "243",
    slug: "মতলব-দক্ষিণ"
  },
  {
    name: "হাইমচর",
    "external-id": "1808",
    "parent-external-id": "243",
    slug: "হাইমচর"
  },
  {
    name: "বরুরা",
    "external-id": "1784",
    "parent-external-id": "144",
    slug: "বরুরা"
  },
  {
    name: "চান্দিনা",
    "external-id": "1786",
    "parent-external-id": "144",
    slug: "চান্দিনা"
  },
  {
    name: "দাউদকান্দি",
    "external-id": "388",
    "parent-external-id": "144",
    slug: "দাউদকান্দি"
  },
  {
    name: "লাকসাম",
    "external-id": "425",
    "parent-external-id": "144",
    slug: "লাকসাম"
  },
  {
    name: "ব্রাহ্মণপাড়া",
    "external-id": "601",
    "parent-external-id": "144",
    slug: "ব্রাহ্মণপাড়া"
  },
  {
    name: "বুড়িচং",
    "external-id": "1788",
    "parent-external-id": "144",
    slug: "বুড়িচং"
  },
  {
    name: "চৌদ্দগ্রাম",
    "external-id": "671",
    "parent-external-id": "144",
    slug: "চৌদ্দগ্রাম"
  },
  {
    name: "দেবীদ্বার",
    "external-id": "765",
    "parent-external-id": "144",
    slug: "দেবীদ্বার"
  },
  {
    name: "হোমনা",
    "external-id": "1790",
    "parent-external-id": "144",
    slug: "হোমনা"
  },
  {
    name: "মুরাদনগর",
    "external-id": "1792",
    "parent-external-id": "144",
    slug: "মুরাদনগর"
  },
  {
    name: "লাঙ্গলকোট",
    "external-id": "1794",
    "parent-external-id": "144",
    slug: "লাঙ্গলকোট"
  },
  {
    name: "মেঘনা",
    "external-id": "1796",
    "parent-external-id": "144",
    slug: "মেঘনা"
  },
  {
    name: "তিতাস",
    "external-id": "1798",
    "parent-external-id": "144",
    slug: "তিতাস"
  },
  {
    name: "মনোহরগঞ্জ",
    "external-id": "389",
    "parent-external-id": "144",
    slug: "মনোহরগঞ্জ"
  },
  {
    name: "উখিয়া",
    "external-id": "1038",
    "parent-external-id": "264",
    slug: "উখিয়া"
  },
  {
    name: "কক্সবাজার সদর",
    "external-id": "1714",
    "parent-external-id": "264",
    slug: "কক্সবাজার-সদর"
  },
  {
    name: "কুতুবদিয়া",
    "external-id": "1716",
    "parent-external-id": "264",
    slug: "কুতুবদিয়া"
  },
  {
    name: "চকরিয়া",
    "external-id": "458",
    "parent-external-id": "264",
    slug: "চকরিয়া"
  },
  {
    name: "টেকনাফ",
    "external-id": "409",
    "parent-external-id": "264",
    slug: "টেকনাফ"
  },
  {
    name: "মহেশখালী",
    "external-id": "265",
    "parent-external-id": "264",
    slug: "মহেশখালী"
  },
  {
    name: "রামু",
    "external-id": "537",
    "parent-external-id": "264",
    slug: "রামু"
  },
  {
    name: "পেকুয়া",
    "external-id": "1718",
    "parent-external-id": "264",
    slug: "পেকুয়া"
  },
  {
    name: "আলিকদম",
    "external-id": "1720",
    "parent-external-id": "376",
    slug: "আলিকদম"
  },
  {
    name: "থানচি",
    "external-id": "788",
    "parent-external-id": "376",
    slug: "থানচি"
  },
  {
    name: "নাইক্ষ্যংছড়ি",
    "external-id": "1722",
    "parent-external-id": "376",
    slug: "নাইক্ষ্যংছড়ি"
  },
  {
    name: "বান্দরবান সদর",
    "external-id": "1724",
    "parent-external-id": "376",
    slug: "বান্দরবান-সদর"
  },
  {
    name: "রুমা",
    "external-id": "946",
    "parent-external-id": "376",
    slug: "রুমা"
  },
  {
    name: "রোয়াংছড়ি",
    "external-id": "1726",
    "parent-external-id": "376",
    slug: "রোয়াংছড়ি"
  },
  {
    name: "লামা",
    "external-id": "1728",
    "parent-external-id": "376",
    slug: "লামা"
  },
  {
    name: "খাগড়াছড়ি সদর",
    "external-id": "1730",
    "parent-external-id": "337",
    slug: "খাগড়াছড়ি-সদর"
  },
  {
    name: "দীঘিনালা",
    "external-id": "338",
    "parent-external-id": "337",
    slug: "দীঘিনালা"
  },
  {
    name: "পানছড়ি",
    "external-id": "1732",
    "parent-external-id": "337",
    slug: "পানছড়ি"
  },
  {
    name: "মহালছড়ি",
    "external-id": "1734",
    "parent-external-id": "337",
    slug: "মহালছড়ি"
  },
  {
    name: "মাটিরাঙ্গা",
    "external-id": "654",
    "parent-external-id": "337",
    slug: "মাটিরাঙ্গা"
  },
  {
    name: "মানিকছড়ি",
    "external-id": "817",
    "parent-external-id": "337",
    slug: "মানিকছড়ি"
  },
  {
    name: "রামগড়",
    "external-id": "816",
    "parent-external-id": "337",
    slug: "রামগড়"
  },
  {
    name: "লক্ষ্মীছড়ি",
    "external-id": "1736",
    "parent-external-id": "337",
    slug: "লক্ষ্মীছড়ি"
  },
  {
    name: "কাউখালী  (রাঙ্গামাটি)",
    "external-id": "1738",
    "parent-external-id": "262",
    slug: "কাউখালী--(রাঙ্গামাটি)"
  },
  {
    name: "কাপ্তাই",
    "external-id": "532",
    "parent-external-id": "262",
    slug: "কাপ্তাই"
  },
  {
    name: "জুরাছড়ি",
    "external-id": "1740",
    "parent-external-id": "262",
    slug: "জুরাছড়ি"
  },
  {
    name: "নানিয়ারচর",
    "external-id": "1742",
    "parent-external-id": "262",
    slug: "নানিয়ারচর"
  },
  {
    name: "বরকল",
    "external-id": "1744",
    "parent-external-id": "262",
    slug: "বরকল"
  },
  {
    name: "বাঘাইছড়ি",
    "external-id": "377",
    "parent-external-id": "262",
    slug: "বাঘাইছড়ি"
  },
  {
    name: "বিলাইছড়ি",
    "external-id": "942",
    "parent-external-id": "262",
    slug: "বিলাইছড়ি"
  },
  {
    name: "রাঙামাটি সদর",
    "external-id": "1746",
    "parent-external-id": "262",
    slug: "রাঙামাটি-সদর"
  },
  {
    name: "রাজস্থলী",
    "external-id": "1748",
    "parent-external-id": "262",
    slug: "রাজস্থলী"
  },
  {
    name: "লংগদু",
    "external-id": "1750",
    "parent-external-id": "262",
    slug: "লংগদু"
  },
  {
    name: "নোয়াখালী সদর",
    "external-id": "1752",
    "parent-external-id": "266",
    slug: "নোয়াখালী-সদর"
  },
  {
    name: "বেগমগঞ্জ",
    "external-id": "1754",
    "parent-external-id": "266",
    slug: "বেগমগঞ্জ"
  },
  {
    name: "চাটখিল",
    "external-id": "1756",
    "parent-external-id": "266",
    slug: "চাটখিল"
  },
  {
    name: "কোম্পানীগঞ্জ",
    "external-id": "1758",
    "parent-external-id": "266",
    slug: "কোম্পানীগঞ্জ"
  },
  {
    name: "হাতিয়া",
    "external-id": "334",
    "parent-external-id": "266",
    slug: "হাতিয়া"
  },
  {
    name: "সেনবাগ",
    "external-id": "1760",
    "parent-external-id": "266",
    slug: "সেনবাগ"
  },
  {
    name: "সুবর্ণচর",
    "external-id": "1762",
    "parent-external-id": "266",
    slug: "সুবর্ণচর"
  },
  {
    name: "সোনাইমুড়ি",
    "external-id": "1764",
    "parent-external-id": "266",
    slug: "সোনাইমুড়ি"
  },
  {
    name: "কবিরহাট",
    "external-id": "1766",
    "parent-external-id": "266",
    slug: "কবিরহাট"
  },
  {
    name: "লক্ষ্মীপুর সদর",
    "external-id": "1768",
    "parent-external-id": "441",
    slug: "লক্ষ্মীপুর-সদর"
  },
  {
    name: "রায়পুর",
    "external-id": "440",
    "parent-external-id": "441",
    slug: "রায়পুর"
  },
  {
    name: "রামগঞ্জ",
    "external-id": "1770",
    "parent-external-id": "441",
    slug: "রামগঞ্জ"
  },
  {
    name: "কমলনগর",
    "external-id": "1772",
    "parent-external-id": "441",
    slug: "কমলনগর"
  },
  {
    name: "রামগতি",
    "external-id": "555",
    "parent-external-id": "441",
    slug: "রামগতি"
  },
  {
    name: "ফেনী সদর",
    "external-id": "1774",
    "parent-external-id": "333",
    slug: "ফেনী-সদর"
  },
  {
    name: "দাগনভূঁইয়া",
    "external-id": "1776",
    "parent-external-id": "333",
    slug: "দাগনভূঁইয়া"
  },
  {
    name: "সোনাগাজী",
    "external-id": "1778",
    "parent-external-id": "333",
    slug: "সোনাগাজী"
  },
  {
    name: "ছাগলনাইয়া",
    "external-id": "1780",
    "parent-external-id": "333",
    slug: "ছাগলনাইয়া"
  },
  {
    name: "পরশুরাম",
    "external-id": "1782",
    "parent-external-id": "333",
    slug: "পরশুরাম"
  },
  {
    name: "ফুলগাজী",
    "external-id": "842",
    "parent-external-id": "333",
    slug: "ফুলগাজী"
  },
  {
    name: "আশুগঞ্জ",
    "external-id": "1812",
    "parent-external-id": "328",
    slug: "আশুগঞ্জ"
  },
  {
    name: "আখাউড়া",
    "external-id": "556",
    "parent-external-id": "328",
    slug: "আখাউড়া"
  },
  {
    name: "কসবা",
    "external-id": "442",
    "parent-external-id": "328",
    slug: "কসবা"
  },
  {
    name: "নবীনগর",
    "external-id": "382",
    "parent-external-id": "328",
    slug: "নবীনগর"
  },
  {
    name: "নাসিরনগর",
    "external-id": "1814",
    "parent-external-id": "328",
    slug: "নাসিরনগর"
  },
  {
    name: "বাঞ্ছারামপুর",
    "external-id": "357",
    "parent-external-id": "328",
    slug: "বাঞ্ছারামপুর"
  },
  {
    name: "ব্রাহ্মণবাড়িয়া সদর",
    "external-id": "1816",
    "parent-external-id": "328",
    slug: "ব্রাহ্মণবাড়িয়া-সদর"
  },
  {
    name: "সরাইল",
    "external-id": "379",
    "parent-external-id": "328",
    slug: "সরাইল"
  },
  {
    name: "বিজয়নগর",
    "external-id": "1818",
    "parent-external-id": "328",
    slug: "বিজয়নগর"
  },
  {
    name: "সিলেট সিটি",
    "external-id": "1344",
    "parent-external-id": "88",
    slug: "সিলেট-সিটি"
  },
  {
    name: "বালাগঞ্জ",
    "external-id": "1342",
    "parent-external-id": "88",
    slug: "বালাগঞ্জ"
  },
  {
    name: "বিয়ানীবাজার",
    "external-id": "766",
    "parent-external-id": "88",
    slug: "বিয়ানীবাজার"
  },
  {
    name: "বিশ্বনাথ",
    "external-id": "712",
    "parent-external-id": "88",
    slug: "বিশ্বনাথ"
  },
  {
    name: "কোম্পানীগঞ্জ",
    "external-id": "1340",
    "parent-external-id": "88",
    slug: "কোম্পানীগঞ্জ"
  },
  {
    name: "ফেঞ্চুগঞ্জ",
    "external-id": "779",
    "parent-external-id": "88",
    slug: "ফেঞ্চুগঞ্জ"
  },
  {
    name: "গোলাপগঞ্জ",
    "external-id": "497",
    "parent-external-id": "88",
    slug: "গোলাপগঞ্জ"
  },
  {
    name: "গোয়াইঘাট",
    "external-id": "1338",
    "parent-external-id": "88",
    slug: "গোয়াইঘাট"
  },
  {
    name: "জৈন্তাপুর",
    "external-id": "1062",
    "parent-external-id": "88",
    slug: "জৈন্তাপুর"
  },
  {
    name: "কানাইঘাট",
    "external-id": "1336",
    "parent-external-id": "88",
    slug: "কানাইঘাট"
  },
  {
    name: "সিলেট সদর",
    "external-id": "1334",
    "parent-external-id": "88",
    slug: "সিলেট-সদর"
  },
  {
    name: "জকিগঞ্জ",
    "external-id": "1332",
    "parent-external-id": "88",
    slug: "জকিগঞ্জ"
  },
  {
    name: "দক্ষিণ সুরমা",
    "external-id": "1330",
    "parent-external-id": "88",
    slug: "দক্ষিণ-সুরমা"
  },
  {
    name: "আজমিরিগঞ্জ",
    "external-id": "1328",
    "parent-external-id": "260",
    slug: "আজমিরিগঞ্জ"
  },
  {
    name: "বানিয়াচং",
    "external-id": "1326",
    "parent-external-id": "260",
    slug: "বানিয়াচং"
  },
  {
    name: "বাহুবল",
    "external-id": "1324",
    "parent-external-id": "260",
    slug: "বাহুবল"
  },
  {
    name: "চুনারুঘাট",
    "external-id": "1322",
    "parent-external-id": "260",
    slug: "চুনারুঘাট"
  },
  {
    name: "হবিগঞ্জ সদর",
    "external-id": "1320",
    "parent-external-id": "260",
    slug: "হবিগঞ্জ-সদর"
  },
  {
    name: "লাখাই",
    "external-id": "1318",
    "parent-external-id": "260",
    slug: "লাখাই"
  },
  {
    name: "নবীগঞ্জ",
    "external-id": "482",
    "parent-external-id": "260",
    slug: "নবীগঞ্জ"
  },
  {
    name: "মাধবপুর",
    "external-id": "381",
    "parent-external-id": "260",
    slug: "মাধবপুর"
  },
  {
    name: "বড়লেখা",
    "external-id": "1316",
    "parent-external-id": "244",
    slug: "বড়লেখা"
  },
  {
    name: "কুলাউড়া",
    "external-id": "872",
    "parent-external-id": "244",
    slug: "কুলাউড়া"
  },
  {
    name: "রাজানগর",
    "external-id": "1314",
    "parent-external-id": "244",
    slug: "রাজানগর"
  },
  {
    name: "কমলগঞ্জ",
    "external-id": "443",
    "parent-external-id": "244",
    slug: "কমলগঞ্জ"
  },
  {
    name: "শ্রীমঙ্গল",
    "external-id": "460",
    "parent-external-id": "244",
    slug: "শ্রীমঙ্গল"
  },
  {
    name: "মৌলভীবাজার সদর",
    "external-id": "1312",
    "parent-external-id": "244",
    slug: "মৌলভীবাজার-সদর"
  },
  {
    name: "জুড়ি",
    "external-id": "1310",
    "parent-external-id": "244",
    slug: "জুড়ি"
  },
  {
    name: "বিশ্বম্ভরপুর",
    "external-id": "1308",
    "parent-external-id": "252",
    slug: "বিশ্বম্ভরপুর"
  },
  {
    name: "ছাতক",
    "external-id": "1306",
    "parent-external-id": "252",
    slug: "ছাতক"
  },
  {
    name: "দিরাই",
    "external-id": "327",
    "parent-external-id": "252",
    slug: "দিরাই"
  },
  {
    name: "ধর্মপাশা",
    "external-id": "1304",
    "parent-external-id": "252",
    slug: "ধর্মপাশা"
  },
  {
    name: "দোয়ারাবাজার",
    "external-id": "1302",
    "parent-external-id": "252",
    slug: "দোয়ারাবাজার"
  },
  {
    name: "জগন্নাথপুর",
    "external-id": "251",
    "parent-external-id": "252",
    slug: "জগন্নাথপুর"
  },
  {
    name: "জামালগঞ্জ",
    "external-id": "1300",
    "parent-external-id": "252",
    slug: "জামালগঞ্জ"
  },
  {
    name: "তাহিরপুর",
    "external-id": "484",
    "parent-external-id": "252",
    slug: "তাহিরপুর"
  },
  {
    name: "শাল্লা",
    "external-id": "1298",
    "parent-external-id": "252",
    slug: "শাল্লা"
  },
  {
    name: "সুনামগঞ্জ সদর",
    "external-id": "1296",
    "parent-external-id": "252",
    slug: "সুনামগঞ্জ-সদর"
  },
  {
    name: "আগৈলঝারা",
    "external-id": "1404",
    "parent-external-id": "92",
    slug: "আগৈলঝারা"
  },
  {
    name: "বাকেরগঞ্জ",
    "external-id": "1402",
    "parent-external-id": "92",
    slug: "বাকেরগঞ্জ"
  },
  {
    name: "বাবুগঞ্জ",
    "external-id": "1400",
    "parent-external-id": "92",
    slug: "বাবুগঞ্জ"
  },
  {
    name: "বানারিপাড়া",
    "external-id": "1398",
    "parent-external-id": "92",
    slug: "বানারিপাড়া"
  },
  {
    name: "গৌরনদী",
    "external-id": "271",
    "parent-external-id": "92",
    slug: "গৌরনদী"
  },
  {
    name: "হিজলা",
    "external-id": "1396",
    "parent-external-id": "92",
    slug: "হিজলা"
  },
  {
    name: "বরিশাল সদর",
    "external-id": "1394",
    "parent-external-id": "92",
    slug: "বরিশাল-সদর"
  },
  {
    name: "মেহেন্দিগঞ্জ",
    "external-id": "1392",
    "parent-external-id": "92",
    slug: "মেহেন্দিগঞ্জ"
  },
  {
    name: "মুলাদি",
    "external-id": "1390",
    "parent-external-id": "92",
    slug: "মুলাদি"
  },
  {
    name: "উজিরপুর",
    "external-id": "676",
    "parent-external-id": "92",
    slug: "উজিরপুর"
  },
  {
    name: "বরগুনা সদর",
    "external-id": "1388",
    "parent-external-id": "275",
    slug: "বরগুনা-সদর"
  },
  {
    name: "আমতলী",
    "external-id": "308",
    "parent-external-id": "275",
    slug: "আমতলী"
  },
  {
    name: "পাথরঘাটা",
    "external-id": "276",
    "parent-external-id": "275",
    slug: "পাথরঘাটা"
  },
  {
    name: "বেতাগি",
    "external-id": "1386",
    "parent-external-id": "275",
    slug: "বেতাগি"
  },
  {
    name: "বামনা",
    "external-id": "1384",
    "parent-external-id": "275",
    slug: "বামনা"
  },
  {
    name: "চরফ্যাশন",
    "external-id": "580",
    "parent-external-id": "324",
    slug: "চরফ্যাশন"
  },
  {
    name: "তজমুদ্দিন",
    "external-id": "1382",
    "parent-external-id": "324",
    slug: "তজমুদ্দিন"
  },
  {
    name: "দৌলতখান",
    "external-id": "1380",
    "parent-external-id": "324",
    slug: "দৌলতখান"
  },
  {
    name: "বোরহানউদ্দিন",
    "external-id": "1378",
    "parent-external-id": "324",
    slug: "বোরহানউদ্দিন"
  },
  {
    name: "ভোলা সদর",
    "external-id": "1376",
    "parent-external-id": "324",
    slug: "ভোলা-সদর"
  },
  {
    name: "মনপুরা",
    "external-id": "1374",
    "parent-external-id": "324",
    slug: "মনপুরা"
  },
  {
    name: "লালমোহন",
    "external-id": "705",
    "parent-external-id": "324",
    slug: "লালমোহন"
  },
  {
    name: "কাঁঠালিয়া",
    "external-id": "1372",
    "parent-external-id": "339",
    slug: "কাঁঠালিয়া"
  },
  {
    name: "ঝালকাঠি সদর",
    "external-id": "1370",
    "parent-external-id": "339",
    slug: "ঝালকাঠি-সদর"
  },
  {
    name: "নলছিটি",
    "external-id": "1368",
    "parent-external-id": "339",
    slug: "নলছিটি"
  },
  {
    name: "রাজাপুর",
    "external-id": "1040",
    "parent-external-id": "339",
    slug: "রাজাপুর"
  },
  {
    name: "পটুয়াখালী সদর",
    "external-id": "1366",
    "parent-external-id": "355",
    slug: "পটুয়াখালী-সদর"
  },
  {
    name: "বাউফল",
    "external-id": "535",
    "parent-external-id": "355",
    slug: "বাউফল"
  },
  {
    name: "দশমিনা",
    "external-id": "1364",
    "parent-external-id": "355",
    slug: "দশমিনা"
  },
  {
    name: "গলাচিপা",
    "external-id": "465",
    "parent-external-id": "355",
    slug: "গলাচিপা"
  },
  {
    name: "কলাপাড়া",
    "external-id": "579",
    "parent-external-id": "355",
    slug: "কলাপাড়া"
  },
  {
    name: "মির্জাগঞ্জ",
    "external-id": "1362",
    "parent-external-id": "355",
    slug: "মির্জাগঞ্জ"
  },
  {
    name: "দুমকি",
    "external-id": "1360",
    "parent-external-id": "355",
    slug: "দুমকি"
  },
  {
    name: "রাঙ্গাবালি",
    "external-id": "1358",
    "parent-external-id": "355",
    slug: "রাঙ্গাবালি"
  },
  {
    name: "কাউখালী  (পিরোজপুর)",
    "external-id": "1356",
    "parent-external-id": "307",
    slug: "কাউখালী--(পিরোজপুর)"
  },
  {
    name: "নাজিরপুর",
    "external-id": "1354",
    "parent-external-id": "307",
    slug: "নাজিরপুর"
  },
  {
    name: "নেছারাবাদ (স্বরূপকাঠি)",
    "external-id": "1352",
    "parent-external-id": "307",
    slug: "নেছারাবাদ-(স্বরূপকাঠি)"
  },
  {
    name: "পিরোজপুর সদর",
    "external-id": "1350",
    "parent-external-id": "307",
    slug: "পিরোজপুর-সদর"
  },
  {
    name: "ভাণ্ডারিয়া",
    "external-id": "1348",
    "parent-external-id": "307",
    slug: "ভাণ্ডারিয়া"
  },
  {
    name: "মঠবাড়িয়া",
    "external-id": "306",
    "parent-external-id": "307",
    slug: "মঠবাড়িয়া"
  },
  {
    name: "জিয়ানগর",
    "external-id": "1346",
    "parent-external-id": "307",
    slug: "জিয়ানগর"
  },
  {
    name: "রাজশাহী সিটি",
    "external-id": "1680",
    "parent-external-id": "50",
    slug: "রাজশাহী-সিটি"
  },
  {
    name: "রাজশাহী সদর",
    "external-id": "1674",
    "parent-external-id": "50",
    slug: "রাজশাহী-সদর"
  },
  {
    name: "বাঘা",
    "external-id": "558",
    "parent-external-id": "50",
    slug: "বাঘা"
  },
  {
    name: "পুঠিয়া",
    "external-id": "1678",
    "parent-external-id": "50",
    slug: "পুঠিয়া"
  },
  {
    name: "পবা",
    "external-id": "960",
    "parent-external-id": "50",
    slug: "পবা"
  },
  {
    name: "বাগমারা",
    "external-id": "321",
    "parent-external-id": "50",
    slug: "বাগমারা"
  },
  {
    name: "তানোর",
    "external-id": "1676",
    "parent-external-id": "50",
    slug: "তানোর"
  },
  {
    name: "বোয়ালিয়া",
    "external-id": "1672",
    "parent-external-id": "50",
    slug: "বোয়ালিয়া"
  },
  {
    name: "মোহনপুর",
    "external-id": "1670",
    "parent-external-id": "50",
    slug: "মোহনপুর"
  },
  {
    name: "চারঘাট",
    "external-id": "1668",
    "parent-external-id": "50",
    slug: "চারঘাট"
  },
  {
    name: "গোদাগারী",
    "external-id": "1666",
    "parent-external-id": "50",
    slug: "গোদাগারী"
  },
  {
    name: "নাটোর সদর",
    "external-id": "1664",
    "parent-external-id": "487",
    slug: "নাটোর-সদর"
  },
  {
    name: "বাগাতিপাড়া",
    "external-id": "956",
    "parent-external-id": "487",
    slug: "বাগাতিপাড়া"
  },
  {
    name: "বরাইগ্রাম",
    "external-id": "1662",
    "parent-external-id": "487",
    slug: "বরাইগ্রাম"
  },
  {
    name: "গুরুদাসপুর",
    "external-id": "486",
    "parent-external-id": "487",
    slug: "গুরুদাসপুর"
  },
  {
    name: "লালপুর",
    "external-id": "625",
    "parent-external-id": "487",
    slug: "লালপুর"
  },
  {
    name: "সিংড়া",
    "external-id": "498",
    "parent-external-id": "487",
    slug: "সিংড়া"
  },
  {
    name: "চাঁপাইনবাবগঞ্জ সদর",
    "external-id": "1660",
    "parent-external-id": "343",
    slug: "চাঁপাইনবাবগঞ্জ-সদর"
  },
  {
    name: "গোমস্তাপুর",
    "external-id": "874",
    "parent-external-id": "343",
    slug: "গোমস্তাপুর"
  },
  {
    name: "শিবগঞ্জ",
    "external-id": "373",
    "parent-external-id": "343",
    slug: "শিবগঞ্জ"
  },
  {
    name: "নাচোল",
    "external-id": "1658",
    "parent-external-id": "343",
    slug: "নাচোল"
  },
  {
    name: "ভোলাহাট",
    "external-id": "651",
    "parent-external-id": "343",
    slug: "ভোলাহাট"
  },
  {
    name: "পাঁচবিবি",
    "external-id": "1656",
    "parent-external-id": "1652",
    slug: "পাঁচবিবি"
  },
  {
    name: "কালাই",
    "external-id": "1654",
    "parent-external-id": "1652",
    slug: "কালাই"
  },
  {
    name: "ক্ষেতলাল",
    "external-id": "1008",
    "parent-external-id": "1652",
    slug: "ক্ষেতলাল"
  },
  {
    name: "আক্কেলপুর",
    "external-id": "304",
    "parent-external-id": "1652",
    slug: "আক্কেলপুর"
  },
  {
    name: "জয়পুরহাট সদর",
    "external-id": "1652",
    "parent-external-id": "1652",
    slug: "জয়পুরহাট-সদর"
  },
  {
    name: "নওগাঁ সদর",
    "external-id": "1554",
    "parent-external-id": "280",
    slug: "নওগাঁ-সদর"
  },
  {
    name: "পত্নীতলা",
    "external-id": "1612",
    "parent-external-id": "280",
    slug: "পত্নীতলা"
  },
  {
    name: "ধামুরহাট",
    "external-id": "1610",
    "parent-external-id": "280",
    slug: "ধামুরহাট"
  },
  {
    name: "মহাদেবপুর",
    "external-id": "868",
    "parent-external-id": "280",
    slug: "মহাদেবপুর"
  },
  {
    name: "পোরশা",
    "external-id": "1600",
    "parent-external-id": "280",
    slug: "পোরশা"
  },
  {
    name: "সাপাহার",
    "external-id": "962",
    "parent-external-id": "280",
    slug: "সাপাহার"
  },
  {
    name: "বাদলগাছি",
    "external-id": "1588",
    "parent-external-id": "280",
    slug: "বাদলগাছি"
  },
  {
    name: "বাদলগাছি",
    "external-id": "1570",
    "parent-external-id": "280",
    slug: "বাদলগাছি"
  },
  {
    name: "নিয়ামতপুর",
    "external-id": "539",
    "parent-external-id": "280",
    slug: "নিয়ামতপুর"
  },
  {
    name: "আত্রাই",
    "external-id": "1562",
    "parent-external-id": "280",
    slug: "আত্রাই"
  },
  {
    name: "রানীনগর",
    "external-id": "1556",
    "parent-external-id": "280",
    slug: "রানীনগর"
  },
  {
    name: "আদমদিঘী",
    "external-id": "1544",
    "parent-external-id": "277",
    slug: "আদমদিঘী"
  },
  {
    name: "বগুড়া সদর",
    "external-id": "1540",
    "parent-external-id": "277",
    slug: "বগুড়া-সদর"
  },
  {
    name: "ধুনট",
    "external-id": "353",
    "parent-external-id": "277",
    slug: "ধুনট"
  },
  {
    name: "ধুপচাঁচিয়া",
    "external-id": "1536",
    "parent-external-id": "277",
    slug: "ধুপচাঁচিয়া"
  },
  {
    name: "গাবতলী",
    "external-id": "309",
    "parent-external-id": "277",
    slug: "গাবতলী"
  },
  {
    name: "কাহালু",
    "external-id": "1532",
    "parent-external-id": "277",
    slug: "কাহালু"
  },
  {
    name: "নন্দীগ্রাম",
    "external-id": "1530",
    "parent-external-id": "277",
    slug: "নন্দীগ্রাম"
  },
  {
    name: "সারিয়াকান্দি",
    "external-id": "1526",
    "parent-external-id": "277",
    slug: "সারিয়াকান্দি"
  },
  {
    name: "শেরপুর",
    "external-id": "278",
    "parent-external-id": "277",
    slug: "শেরপুর"
  },
  {
    name: "সোনাতলা",
    "external-id": "1522",
    "parent-external-id": "277",
    slug: "সোনাতলা"
  },
  {
    name: "সাজাহানপুর",
    "external-id": "1520",
    "parent-external-id": "277",
    slug: "সাজাহানপুর"
  },
  {
    name: "আটঘরিয়া",
    "external-id": "1516",
    "parent-external-id": "320",
    slug: "আটঘরিয়া"
  },
  {
    name: "ঈশ্বরদী",
    "external-id": "354",
    "parent-external-id": "320",
    slug: "ঈশ্বরদী"
  },
  {
    name: "চাটমোহর",
    "external-id": "1514",
    "parent-external-id": "320",
    slug: "চাটমোহর"
  },
  {
    name: "পাবনা সদর",
    "external-id": "1512",
    "parent-external-id": "320",
    slug: "পাবনা-সদর"
  },
  {
    name: "ফরিদপুর",
    "external-id": "1510",
    "parent-external-id": "320",
    slug: "ফরিদপুর"
  },
  {
    name: "বেড়া",
    "external-id": "689",
    "parent-external-id": "320",
    slug: "বেড়া"
  },
  {
    name: "ভাঙ্গুরা",
    "external-id": "1506",
    "parent-external-id": "320",
    slug: "ভাঙ্গুরা"
  },
  {
    name: "সুজানগর",
    "external-id": "802",
    "parent-external-id": "320",
    slug: "সুজানগর"
  },
  {
    name: "সাঁথিয়া",
    "external-id": "803",
    "parent-external-id": "320",
    slug: "সাঁথিয়া"
  },
  {
    name: "বেলকুচি",
    "external-id": "1112",
    "parent-external-id": "281",
    slug: "বেলকুচি"
  },
  {
    name: "কামারখন্দ",
    "external-id": "1504",
    "parent-external-id": "281",
    slug: "কামারখন্দ"
  },
  {
    name: "চৌহালি",
    "external-id": "1502",
    "parent-external-id": "281",
    slug: "চৌহালি"
  },
  {
    name: "কাজীপুর",
    "external-id": "1500",
    "parent-external-id": "281",
    slug: "কাজীপুর"
  },
  {
    name: "রায়গঞ্জ",
    "external-id": "436",
    "parent-external-id": "281",
    slug: "রায়গঞ্জ"
  },
  {
    name: "শাহজাদপুর",
    "external-id": "358",
    "parent-external-id": "281",
    slug: "শাহজাদপুর"
  },
  {
    name: "সিরাজগঞ্জ সদর",
    "external-id": "1498",
    "parent-external-id": "281",
    slug: "সিরাজগঞ্জ-সদর"
  },
  {
    name: "তাড়াশ",
    "external-id": "608",
    "parent-external-id": "281",
    slug: "তাড়াশ"
  },
  {
    name: "উল্লাপাড়া",
    "external-id": "1124",
    "parent-external-id": "281",
    slug: "উল্লাপাড়া"
  },
  {
    name: "খুলনা সিটি",
    "external-id": "1496",
    "parent-external-id": "90",
    slug: "খুলনা-সিটি"
  },
  {
    name: "কয়রা",
    "external-id": "1494",
    "parent-external-id": "90",
    slug: "কয়রা"
  },
  {
    name: "ডুমুরিয়া",
    "external-id": "352",
    "parent-external-id": "90",
    slug: "ডুমুরিয়া"
  },
  {
    name: "তেরখাদা",
    "external-id": "1492",
    "parent-external-id": "90",
    slug: "তেরখাদা"
  },
  {
    name: "দাকোপ",
    "external-id": "906",
    "parent-external-id": "90",
    slug: "দাকোপ"
  },
  {
    name: "দীঘলিয়া",
    "external-id": "1490",
    "parent-external-id": "90",
    slug: "দীঘলিয়া"
  },
  {
    name: "পাইকগাছা",
    "external-id": "1488",
    "parent-external-id": "90",
    slug: "পাইকগাছা"
  },
  {
    name: "ফুলতলা",
    "external-id": "360",
    "parent-external-id": "90",
    slug: "ফুলতলা"
  },
  {
    name: "বটিয়াঘাটা",
    "external-id": "1486",
    "parent-external-id": "90",
    slug: "বটিয়াঘাটা"
  },
  {
    name: "রূপসা",
    "external-id": "1484",
    "parent-external-id": "90",
    slug: "রূপসা"
  },
  {
    name: "কচুয়া (বাগেরহাট)",
    "external-id": "1482",
    "parent-external-id": "285",
    slug: "কচুয়া-(বাগেরহাট)"
  },
  {
    name: "চিতলমারী",
    "external-id": "1480",
    "parent-external-id": "285",
    slug: "চিতলমারী"
  },
  {
    name: "ফকিরহাট",
    "external-id": "624",
    "parent-external-id": "285",
    slug: "ফকিরহাট"
  },
  {
    name: "বাগেরহাট সদর",
    "external-id": "1478",
    "parent-external-id": "285",
    slug: "বাগেরহাট-সদর"
  },
  {
    name: "মংলা",
    "external-id": "628",
    "parent-external-id": "285",
    slug: "মংলা"
  },
  {
    name: "মোরেলগঞ্জ",
    "external-id": "284",
    "parent-external-id": "285",
    slug: "মোরেলগঞ্জ"
  },
  {
    name: "মোল্লাহাট",
    "external-id": "517",
    "parent-external-id": "285",
    slug: "মোল্লাহাট"
  },
  {
    name: "রামপাল",
    "external-id": "634",
    "parent-external-id": "285",
    slug: "রামপাল"
  },
  {
    name: "শরণখোলা",
    "external-id": "1476",
    "parent-external-id": "285",
    slug: "শরণখোলা"
  },
  {
    name: "আলমডাঙ্গা",
    "external-id": "1130",
    "parent-external-id": "364",
    slug: "আলমডাঙ্গা"
  },
  {
    name: "চুয়াডাঙ্গা সদর",
    "external-id": "1474",
    "parent-external-id": "364",
    slug: "চুয়াডাঙ্গা-সদর"
  },
  {
    name: "দামুড়হুদা",
    "external-id": "1472",
    "parent-external-id": "364",
    slug: "দামুড়হুদা"
  },
  {
    name: "জীবননগর",
    "external-id": "1470",
    "parent-external-id": "364",
    slug: "জীবননগর"
  },
  {
    name: "যশোর সদর",
    "external-id": "1468",
    "parent-external-id": "241",
    slug: "যশোর-সদর"
  },
  {
    name: "অভয়নগর",
    "external-id": "270",
    "parent-external-id": "241",
    slug: "অভয়নগর"
  },
  {
    name: "কেশবপুর",
    "external-id": "1466",
    "parent-external-id": "241",
    slug: "কেশবপুর"
  },
  {
    name: "চৌগাছা",
    "external-id": "1464",
    "parent-external-id": "241",
    slug: "চৌগাছা"
  },
  {
    name: "ঝিকরগাছা",
    "external-id": "1126",
    "parent-external-id": "241",
    slug: "ঝিকরগাছা"
  },
  {
    name: "বাঘারপাড়া",
    "external-id": "1462",
    "parent-external-id": "241",
    slug: "বাঘারপাড়া"
  },
  {
    name: "মনিরামপুর",
    "external-id": "1460",
    "parent-external-id": "241",
    slug: "মনিরামপুর"
  },
  {
    name: "শার্শা",
    "external-id": "1458",
    "parent-external-id": "241",
    slug: "শার্শা"
  },
  {
    name: "কালীগঞ্জ  (ঝিনাইদহ)",
    "external-id": "1456",
    "parent-external-id": "312",
    slug: "কালীগঞ্জ--(ঝিনাইদহ)"
  },
  {
    name: "কোটচাঁদপুর",
    "external-id": "1454",
    "parent-external-id": "312",
    slug: "কোটচাঁদপুর"
  },
  {
    name: "ঝিনাইদহ সদর",
    "external-id": "1452",
    "parent-external-id": "312",
    slug: "ঝিনাইদহ-সদর"
  },
  {
    name: "মহেশপুর",
    "external-id": "1450",
    "parent-external-id": "312",
    slug: "মহেশপুর"
  },
  {
    name: "শৈলকূপা",
    "external-id": "1448",
    "parent-external-id": "312",
    slug: "শৈলকূপা"
  },
  {
    name: "হরিণাকুণ্ড",
    "external-id": "1446",
    "parent-external-id": "312",
    slug: "হরিণাকুণ্ড"
  },
  {
    name: "কুমারখালী",
    "external-id": "1444",
    "parent-external-id": "272",
    slug: "কুমারখালী"
  },
  {
    name: "কুষ্টিয়া সদর",
    "external-id": "1442",
    "parent-external-id": "272",
    slug: "কুষ্টিয়া-সদর"
  },
  {
    name: "খোকসা",
    "external-id": "1440",
    "parent-external-id": "272",
    slug: "খোকসা"
  },
  {
    name: "ভেড়ামারা",
    "external-id": "742",
    "parent-external-id": "272",
    slug: "ভেড়ামারা"
  },
  {
    name: "মিরপুর",
    "external-id": "1438",
    "parent-external-id": "272",
    slug: "মিরপুর"
  },
  {
    name: "মাগুরা সদর",
    "external-id": "1436",
    "parent-external-id": "463",
    slug: "মাগুরা-সদর"
  },
  {
    name: "মোহাম্মদপুর",
    "external-id": "1434",
    "parent-external-id": "463",
    slug: "মোহাম্মদপুর"
  },
  {
    name: "শালিখা",
    "external-id": "1432",
    "parent-external-id": "463",
    slug: "শালিখা"
  },
  {
    name: "গাংনী",
    "external-id": "1430",
    "parent-external-id": "269",
    slug: "গাংনী"
  },
  {
    name: "মেহেরপুর সদর",
    "external-id": "1428",
    "parent-external-id": "269",
    slug: "মেহেরপুর-সদর"
  },
  {
    name: "মুজিবনগর",
    "external-id": "1426",
    "parent-external-id": "269",
    slug: "মুজিবনগর"
  },
  {
    name: "নড়াইল সদর",
    "external-id": "1424",
    "parent-external-id": "248",
    slug: "নড়াইল-সদর"
  },
  {
    name: "কালিয়া",
    "external-id": "1422",
    "parent-external-id": "248",
    slug: "কালিয়া"
  },
  {
    name: "নড়াগাতি",
    "external-id": "1420",
    "parent-external-id": "248",
    slug: "নড়াগাতি"
  },
  {
    name: "আশাশুনি",
    "external-id": "1418",
    "parent-external-id": "274",
    slug: "আশাশুনি"
  },
  {
    name: "কলারোয়া",
    "external-id": "1416",
    "parent-external-id": "274",
    slug: "কলারোয়া"
  },
  {
    name: "কালীগঞ্জ  (সাতক্ষীরা)",
    "external-id": "1414",
    "parent-external-id": "274",
    slug: "কালীগঞ্জ--(সাতক্ষীরা)"
  },
  {
    name: "তালা",
    "external-id": "1412",
    "parent-external-id": "274",
    slug: "তালা"
  },
  {
    name: "দেবহাটা",
    "external-id": "1410",
    "parent-external-id": "274",
    slug: "দেবহাটা"
  },
  {
    name: "শ্যামনগর",
    "external-id": "1408",
    "parent-external-id": "274",
    slug: "শ্যামনগর"
  },
  {
    name: "সাতক্ষীরা সদর",
    "external-id": "1406",
    "parent-external-id": "274",
    slug: "সাতক্ষীরা-সদর"
  },
  {
    name: "রংপুর সিটি",
    "external-id": "1294",
    "parent-external-id": "47",
    slug: "রংপুর-সিটি"
  },
  {
    name: "রংপুর সদর",
    "external-id": "1292",
    "parent-external-id": "47",
    slug: "রংপুর-সদর"
  },
  {
    name: "বদরগঞ্জ",
    "external-id": "413",
    "parent-external-id": "47",
    slug: "বদরগঞ্জ"
  },
  {
    name: "গঙ্গাছড়া",
    "external-id": "1290",
    "parent-external-id": "47",
    slug: "গঙ্গাছড়া"
  },
  {
    name: "কাউনিয়া",
    "external-id": "1288",
    "parent-external-id": "47",
    slug: "কাউনিয়া"
  },
  {
    name: "মিঠাপুকুর",
    "external-id": "757",
    "parent-external-id": "47",
    slug: "মিঠাপুকুর"
  },
  {
    name: "পীরগাছা",
    "external-id": "303",
    "parent-external-id": "47",
    slug: "পীরগাছা"
  },
  {
    name: "পীরগঞ্জ",
    "external-id": "1286",
    "parent-external-id": "47",
    slug: "পীরগঞ্জ"
  },
  {
    name: "তারাগঞ্জ",
    "external-id": "331",
    "parent-external-id": "47",
    slug: "তারাগঞ্জ"
  },
  {
    name: "বিরামপুর",
    "external-id": "317",
    "parent-external-id": "282",
    slug: "বিরামপুর"
  },
  {
    name: "বীরগঞ্জ",
    "external-id": "1284",
    "parent-external-id": "282",
    slug: "বীরগঞ্জ"
  },
  {
    name: "বোচাগঞ্জ",
    "external-id": "1282",
    "parent-external-id": "282",
    slug: "বোচাগঞ্জ"
  },
  {
    name: "ফুলবাড়ী",
    "external-id": "494",
    "parent-external-id": "282",
    slug: "ফুলবাড়ী"
  },
  {
    name: "চিরিরবন্দর",
    "external-id": "1280",
    "parent-external-id": "282",
    slug: "চিরিরবন্দর"
  },
  {
    name: "ঘোড়াঘাট",
    "external-id": "1278",
    "parent-external-id": "282",
    slug: "ঘোড়াঘাট"
  },
  {
    name: "হাকিমপুর",
    "external-id": "316",
    "parent-external-id": "282",
    slug: "হাকিমপুর"
  },
  {
    name: "কাহারোল",
    "external-id": "1276",
    "parent-external-id": "282",
    slug: "কাহারোল"
  },
  {
    name: "খানসামা",
    "external-id": "1274",
    "parent-external-id": "282",
    slug: "খানসামা"
  },
  {
    name: "দিনাজপুর সদর",
    "external-id": "1272",
    "parent-external-id": "282",
    slug: "দিনাজপুর-সদর"
  },
  {
    name: "পার্বতীপুর",
    "external-id": "361",
    "parent-external-id": "282",
    slug: "পার্বতীপুর"
  },
  {
    name: "বিরল",
    "external-id": "1270",
    "parent-external-id": "282",
    slug: "বিরল"
  },
  {
    name: "গাইবান্ধা সদর",
    "external-id": "1268",
    "parent-external-id": "322",
    slug: "গাইবান্ধা-সদর"
  },
  {
    name: "ফুলছড়ি",
    "external-id": "1266",
    "parent-external-id": "322",
    slug: "ফুলছড়ি"
  },
  {
    name: "গোবিন্দগঞ্জ",
    "external-id": "325",
    "parent-external-id": "322",
    slug: "গোবিন্দগঞ্জ"
  },
  {
    name: "পলাশবাড়ী",
    "external-id": "1264",
    "parent-external-id": "322",
    slug: "পলাশবাড়ী"
  },
  {
    name: "সাদল্লাপুর",
    "external-id": "1262",
    "parent-external-id": "322",
    slug: "সাদল্লাপুর"
  },
  {
    name: "সাঘাটা",
    "external-id": "1260",
    "parent-external-id": "322",
    slug: "সাঘাটা"
  },
  {
    name: "সুন্দরগঞ্জ",
    "external-id": "1100",
    "parent-external-id": "322",
    slug: "সুন্দরগঞ্জ"
  },
  {
    name: "উলিপুর",
    "external-id": "1258",
    "parent-external-id": "301",
    slug: "উলিপুর"
  },
  {
    name: "কুড়িগ্রাম সদর",
    "external-id": "1256",
    "parent-external-id": "301",
    slug: "কুড়িগ্রাম-সদর"
  },
  {
    name: "চর রাজীবপুর",
    "external-id": "1254",
    "parent-external-id": "301",
    slug: "চর-রাজীবপুর"
  },
  {
    name: "চিলমারী",
    "external-id": "1252",
    "parent-external-id": "301",
    slug: "চিলমারী"
  },
  {
    name: "নাগেশ্বরী",
    "external-id": "1144",
    "parent-external-id": "301",
    slug: "নাগেশ্বরী"
  },
  {
    name: "ফুলবাড়ী",
    "external-id": "1250",
    "parent-external-id": "301",
    slug: "ফুলবাড়ী"
  },
  {
    name: "ভুরুঙ্গামারী",
    "external-id": "1248",
    "parent-external-id": "301",
    slug: "ভুরুঙ্গামারী"
  },
  {
    name: "রাজারহাট",
    "external-id": "1246",
    "parent-external-id": "301",
    slug: "রাজারহাট"
  },
  {
    name: "রৌমারী",
    "external-id": "1244",
    "parent-external-id": "301",
    slug: "রৌমারী"
  },
  {
    name: "নিলফামারী সদর",
    "external-id": "1198",
    "parent-external-id": "283",
    slug: "নিলফামারী-সদর"
  },
  {
    name: "ডোমার",
    "external-id": "1196",
    "parent-external-id": "283",
    slug: "ডোমার"
  },
  {
    name: "ডিমলা",
    "external-id": "1194",
    "parent-external-id": "283",
    slug: "ডিমলা"
  },
  {
    name: "জলঢাকা",
    "external-id": "1192",
    "parent-external-id": "283",
    slug: "জলঢাকা"
  },
  {
    name: "কিশোরগঞ্জ",
    "external-id": "1190",
    "parent-external-id": "283",
    slug: "কিশোরগঞ্জ"
  },
  {
    name: "কিশোরগঞ্জ",
    "external-id": "444",
    "parent-external-id": "283",
    slug: "কিশোরগঞ্জ"
  },
  {
    name: "দেবীগঞ্জ",
    "external-id": "1186",
    "parent-external-id": "483",
    slug: "দেবীগঞ্জ"
  },
  {
    name: "তেঁতুলিয়া",
    "external-id": "1182",
    "parent-external-id": "483",
    slug: "তেঁতুলিয়া"
  },
  {
    name: "পঞ্চগড় সদর",
    "external-id": "1176",
    "parent-external-id": "483",
    slug: "পঞ্চগড়-সদর"
  },
  {
    name: "আটোয়ারী",
    "external-id": "890",
    "parent-external-id": "483",
    slug: "আটোয়ারী"
  },
  {
    name: "বোদা",
    "external-id": "1174",
    "parent-external-id": "483",
    slug: "বোদা"
  },
  {
    name: "ঠাকুরগাঁও সদর",
    "external-id": "1172",
    "parent-external-id": "299",
    slug: "ঠাকুরগাঁও-সদর"
  },
  {
    name: "1172",
    "external-id": "462",
    "parent-external-id": "299",
    slug: "1172"
  },
  {
    name: "বালিয়াডাঙ্গী",
    "external-id": "300",
    "parent-external-id": "299",
    slug: "বালিয়াডাঙ্গী"
  },
  {
    name: "রানীশংকৈল",
    "external-id": "1170",
    "parent-external-id": "299",
    slug: "রানীশংকৈল"
  },
  {
    name: "হরিপুর",
    "external-id": "1168",
    "parent-external-id": "299",
    slug: "হরিপুর"
  },
  {
    name: "লালমনিরহাট সদর",
    "external-id": "1166",
    "parent-external-id": "356",
    slug: "লালমনিরহাট-সদর"
  },
  {
    name: "পাটগ্রাম",
    "external-id": "461",
    "parent-external-id": "356",
    slug: "পাটগ্রাম"
  },
  {
    name: "কালীগঞ্জ",
    "external-id": "1164",
    "parent-external-id": "356",
    slug: "কালীগঞ্জ"
  },
  {
    name: "হাতিবান্ধা",
    "external-id": "1162",
    "parent-external-id": "356",
    slug: "হাতিবান্ধা"
  }
];

export const TOPICS_FILTER_PARENT = TOPICS_FILTER.filter(topic => {
  return !topic["parent-external-id"];
});

export const SECTION_MAPPING = [
  { "new-url": "bangladesh/politics", "old-url": "bangladesh-politics" },
  { "new-url": "bangladesh/crime", "old-url": "bangladesh-crime" },
  { "new-url": "bangladesh/justice", "old-url": "bangladesh-justice" },
  { "new-url": "bangladesh/environment", "old-url": "bangladesh-environment" },
  { "new-url": "bangladesh/population", "old-url": "bangladesh-population" },
  { "new-url": "bangladesh/capitalcity", "old-url": "bangladesh-capitalcity" },
  { "new-url": "bangladesh/dhaka", "old-url": "bangladesh-dhaka" },
  { "new-url": "bangladesh/chattogram", "old-url": "bangladesh-chattogram" },
  { "new-url": "bangladesh/barishal", "old-url": "bangladesh-barishal" },
  { "new-url": "bangladesh/rajshahi", "old-url": "bangladesh-rajshahi" },
  { "new-url": "bangladesh/khulna", "old-url": "bangladesh-khulna" },
  { "new-url": "bangladesh/rangpur", "old-url": "bangladesh-rangpur" },
  { "new-url": "bangladesh/sylhet", "old-url": "bangladesh-sylhet" },
  { "new-url": "bangladesh/others", "old-url": "bangladesh-others" },
  { "new-url": "bangladesh/government", "old-url": "bangladesh-government" },
  { "new-url": "bangladesh/accident", "old-url": "bangladesh-accident" },
  { "new-url": "bangladesh/parliament", "old-url": "bangladesh-parliament" },
  { "new-url": "bangladesh/bdr-mutiny", "old-url": "bangladesh-bdr-mutiny" },
  { "new-url": "bangladesh/election", "old-url": "bangladesh-election" },
  { "new-url": "bangladesh/liberation-war", "old-url": "bangladesh-liberation-war" },
  { "new-url": "bangladesh/divisions", "old-url": "bangladesh-divisions" },
  { "new-url": "bangladesh/mymensingh", "old-url": "bangladesh-mymensingh" },
  { "new-url": "bangladesh/flood", "old-url": "bangladesh-flood" },
  { "new-url": "bangladesh/election-sylhet", "old-url": "bangladesh-election-sylhet" },
  { "new-url": "bangladesh/election-rajshahi", "old-url": "bangladesh-election-rajshahi" },
  { "new-url": "bangladesh/election-barishal", "old-url": "bangladesh-election-barishal" },
  { "new-url": "bangladesh/local-news", "old-url": "bangladesh-local-news" },
  { "new-url": "bangladesh/gallery", "old-url": "bangladesh-gallery" },
  { "new-url": "international/usa", "old-url": "international-usa" },
  { "new-url": "international/uk", "old-url": "international-uk" },
  { "new-url": "international/india", "old-url": "international-india" },
  { "new-url": "international/pakistan", "old-url": "international-pakistan" },
  { "new-url": "international/asia", "old-url": "international-asia" },
  { "new-url": "international/europe", "old-url": "international-europe" },
  { "new-url": "international/africa", "old-url": "international-africa" },
  { "new-url": "international/arab-world", "old-url": "international-arab-world" },
  { "new-url": "international/latin-america", "old-url": "international-latin-america" },
  { "new-url": "international/united-nations", "old-url": "international-united-nations" },
  { "new-url": "international/others", "old-url": "international-others" },
  { "new-url": "international/australia", "old-url": "international-australia" },
  { "new-url": "international/canada", "old-url": "international-canada" },
  { "new-url": "international/gallery", "old-url": "international-gallery" },
  { "new-url": "economy/stocks-markets", "old-url": "economy-stocks-markets" },
  { "new-url": "economy/business", "old-url": "economy-business" },
  { "new-url": "economy/analysis", "old-url": "economy-analysis" },
  { "new-url": "economy/garments", "old-url": "economy-garments" },
  { "new-url": "economy/human-resource", "old-url": "economy-human-resource" },
  { "new-url": "economy/crime", "old-url": "economy-crime" },
  { "new-url": "economy/others", "old-url": "economy-others" },
  { "new-url": "economy/budget", "old-url": "economy-budget" },
  { "new-url": "sports/national-football", "old-url": "sports-national-football" },
  { "new-url": "sports/international-football", "old-url": "sports-international-football" },
  { "new-url": "sports/national-cricket", "old-url": "sports-national-cricket" },
  { "new-url": "sports/international-cricket", "old-url": "sports-international-cricket" },
  { "new-url": "sports/tenis", "old-url": "sports-tenis" },
  { "new-url": "sports/athletics", "old-url": "sports-athletics" },
  { "new-url": "sports/interview", "old-url": "sports-interview" },
  { "new-url": "sports/tea-break-conversation", "old-url": "sports-tea-break-conversation" },
  { "new-url": "sports/others", "old-url": "sports-others" },
  { "new-url": "sports/results", "old-url": "sports-results" },
  { "new-url": "sports/t20worldcup2014", "old-url": "sports-t20worldcup2014" },
  { "new-url": "sports/cricket", "old-url": "sports-cricket" },
  { "new-url": "sports/football", "old-url": "sports-football" },
  { "new-url": "sports/champions", "old-url": "sports-champions" },
  { "new-url": "sports/bpl", "old-url": "sports-bpl" },
  { "new-url": "sports/tour-bangladesh", "old-url": "sports-tour-bangladesh" },
  { "new-url": "sports/cricket-series", "old-url": "sports-cricket-series" },
  { "new-url": "sports/bpl-man-of-the-match", "old-url": "sports-bpl-man-of-the-match" },
  { "new-url": "sports/gallery", "old-url": "sports-gallery" },
  { "new-url": "opinion/editorial", "old-url": "opinion-editorial" },
  { "new-url": "opinion/politics", "old-url": "opinion-politics" },
  { "new-url": "opinion/religion", "old-url": "opinion-religion" },
  { "new-url": "opinion/education", "old-url": "opinion-education" },
  { "new-url": "opinion/interview", "old-url": "opinion-interview" },
  { "new-url": "opinion/debate", "old-url": "opinion-debate" },
  { "new-url": "opinion/letter", "old-url": "opinion-letter" },
  { "new-url": "opinion/others", "old-url": "opinion-others" },
  { "new-url": "opinion/society", "old-url": "opinion-society" },
  { "new-url": "life-style/fashion", "old-url": "life-style-fashion" },
  { "new-url": "life-style/style", "old-url": "life-style-style" },
  { "new-url": "life-style/beautification", "old-url": "life-style-beautification" },
  { "new-url": "life-style/travel", "old-url": "life-style-travel" },
  { "new-url": "life-style/relation", "old-url": "life-style-relation" },
  { "new-url": "life-style/advice", "old-url": "life-style-advice" },
  { "new-url": "life-style/doctor", "old-url": "life-style-doctor" },
  { "new-url": "life-style/home-decoration", "old-url": "life-style-home-decoration" },
  { "new-url": "life-style/jenenin", "old-url": "life-style-jenenin" },
  { "new-url": "life-style/recipe", "old-url": "life-style-recipe" },
  { "new-url": "life-style/horoscope", "old-url": "life-style-horoscope" },
  { "new-url": "life-style/others", "old-url": "life-style-others" },
  { "new-url": "life-style/occupation", "old-url": "life-style-occupation" },
  { "new-url": "life-style/gallery", "old-url": "life-style-gallery" },
  { "new-url": "technology/computer", "old-url": "technology-computer" },
  { "new-url": "technology/mobilephone", "old-url": "technology-mobilephone" },
  { "new-url": "technology/automobile", "old-url": "technology-automobile" },
  { "new-url": "technology/research", "old-url": "technology-research" },
  { "new-url": "technology/mohakash", "old-url": "technology-mohakash" },
  { "new-url": "technology/stars", "old-url": "technology-stars" },
  { "new-url": "technology/games", "old-url": "technology-games" },
  { "new-url": "technology/freelancing", "old-url": "technology-freelancing" },
  { "new-url": "technology/review", "old-url": "technology-review" },
  { "new-url": "technology/advice", "old-url": "technology-advice" },
  { "new-url": "technology/multimedia", "old-url": "technology-multimedia" },
  { "new-url": "technology/others", "old-url": "technology-others" },
  { "new-url": "technology/news", "old-url": "technology-news" },
  { "new-url": "technology/symphony", "old-url": "technology-symphony" },
  { "new-url": "technology/gallery", "old-url": "technology-gallery" },
  { "new-url": "education/meritorious", "old-url": "education-meritorious" },
  { "new-url": "education/institution", "old-url": "education-institution" },
  { "new-url": "education/jenerakhun", "old-url": "education-jenerakhun" },
  { "new-url": "education/higher-education", "old-url": "education-higher-education" },
  { "new-url": "education/primary-and-secondary-education", "old-url": "education-primary-and-secondary-education" },
  { "new-url": "education/higher-secondary-education", "old-url": "education-higher-secondary-education" },
  { "new-url": "education/preparation", "old-url": "education-preparation" },
  { "new-url": "education/others", "old-url": "education-others" },
  { "new-url": "entertainment/television", "old-url": "entertainment-television" },
  { "new-url": "entertainment/dhaliwood", "old-url": "entertainment-dhaliwood" },
  { "new-url": "entertainment/music", "old-url": "entertainment-music" },
  { "new-url": "entertainment/bangla-songs", "old-url": "entertainment-bangla-songs" },
  { "new-url": "entertainment/international-songs", "old-url": "entertainment-international-songs" },
  { "new-url": "entertainment/hollywood", "old-url": "entertainment-hollywood" },
  { "new-url": "entertainment/bollywood", "old-url": "entertainment-bollywood" },
  { "new-url": "entertainment/alapon", "old-url": "entertainment-alapon" },
  { "new-url": "entertainment/stage-performance", "old-url": "entertainment-stage-performance" },
  { "new-url": "entertainment/dance", "old-url": "entertainment-dance" },
  { "new-url": "entertainment/somalochona", "old-url": "entertainment-somalochona" },
  { "new-url": "entertainment/tarokader-lekha", "old-url": "entertainment-tarokader-lekha" },
  { "new-url": "entertainment/others", "old-url": "entertainment-others" },
  { "new-url": "entertainment/film", "old-url": "entertainment-film" },
  { "new-url": "entertainment/star-cineplex", "old-url": "entertainment-star-cineplex" },
  { "new-url": "entertainment/gallery", "old-url": "entertainment-gallery" },
  { "new-url": "we-are/torun", "old-url": "we-are-torun" },
  { "new-url": "we-are/kishor", "old-url": "we-are-kishor" },
  { "new-url": "we-are/probashi", "old-url": "we-are-probashi" },
  { "new-url": "we-are/child", "old-url": "we-are-child" },
  { "new-url": "we-are/personality", "old-url": "we-are-personality" },
  { "new-url": "we-are/others", "old-url": "we-are-others" },
  { "new-url": "we-are/international-womens-day", "old-url": "we-are-international-womens-day" },
  { "new-url": "features/female-stage", "old-url": "features-female-stage" },
  { "new-url": "features/naksha", "old-url": "features-naksha" },
  { "new-url": "features/holiday", "old-url": "features-holiday" },
  { "new-url": "features/adhuna", "old-url": "features-adhuna" },
  { "new-url": "features/shapno", "old-url": "features-shapno" },
  { "new-url": "features/ananda", "old-url": "features-ananda" },
  { "new-url": "features/anna-alo", "old-url": "features-anna-alo" },
  { "new-url": "features/shilpo-o-sahitto", "old-url": "features-shilpo-o-sahitto" },
  { "new-url": "features/gollachut", "old-url": "features-gollachut" },
  { "new-url": "features/cholti-bishow", "old-url": "features-cholti-bishow" },
  { "new-url": "features/projonmo-dot-com", "old-url": "features-projonmo-dot-com" },
  { "new-url": "features/sabar-age-shisu", "old-url": "features-sabar-age-shisu" },
  { "new-url": "features/alokito-chattogram", "old-url": "features-alokito-chattogram" },
  { "new-url": "features/roshalo", "old-url": "features-roshalo" },
  { "new-url": "features/amader-kotha-shono", "old-url": "features-amader-kotha-shono" },
  { "new-url": "features/impact-journalism", "old-url": "features-impact-journalism" },
  { "new-url": "features/smart-somoy", "old-url": "features-smart-somoy" },
  { "new-url": "onnoalo/poem", "old-url": "onnoalo-poem" },
  { "new-url": "onnoalo/stories", "old-url": "onnoalo-stories" },
  { "new-url": "onnoalo/treatise", "old-url": "onnoalo-treatise" },
  { "new-url": "onnoalo/books", "old-url": "onnoalo-books" },
  { "new-url": "onnoalo/arts", "old-url": "onnoalo-arts" },
  { "new-url": "onnoalo/interview", "old-url": "onnoalo-interview" },
  { "new-url": "onnoalo/travel", "old-url": "onnoalo-travel" },
  { "new-url": "onnoalo/others", "old-url": "onnoalo-others" },
  { "new-url": "onnoalo/translation", "old-url": "onnoalo-translation" },
  { "new-url": "onnoalo/prose", "old-url": "onnoalo-prose" },
  { "new-url": "photo/gallery", "old-url": "photo-gallery" },
  { "new-url": "todays-paper/durporobashe", "old-url": "todays-paper-durporobashe" },
  { "new-url": "todays-paper/special-page2", "old-url": "todays-paper-special-page2" },
  { "new-url": "todays-paper/bangla", "old-url": "todays-paper-bangla" },
  { "new-url": "todays-paper/first-page", "old-url": "todays-paper-first-page" },
  { "new-url": "todays-paper/country", "old-url": "todays-paper-country" },
  { "new-url": "todays-paper/world", "old-url": "todays-paper-world" },
  { "new-url": "todays-paper/editorial", "old-url": "todays-paper-editorial" },
  { "new-url": "todays-paper/open-column", "old-url": "todays-paper-open-column" },
  { "new-url": "todays-paper/business", "old-url": "todays-paper-business" },
  { "new-url": "todays-paper/capital", "old-url": "todays-paper-capital" },
  { "new-url": "todays-paper/last-page", "old-url": "todays-paper-last-page" },
  { "new-url": "todays-paper/culture", "old-url": "todays-paper-culture" },
  { "new-url": "todays-paper/roundtable", "old-url": "todays-paper-roundtable" },
  { "new-url": "todays-paper/newhorizon", "old-url": "todays-paper-newhorizon" },
  { "new-url": "todays-paper/election", "old-url": "todays-paper-election" },
  { "new-url": "todays-paper/future-world", "old-url": "todays-paper-future-world" },
  { "new-url": "todays-paper/special-page1", "old-url": "todays-paper-special-page1" },
  { "new-url": "todays-paper/joyeeta", "old-url": "todays-paper-joyeeta" },
  { "new-url": "todays-paper/may-dibosh", "old-url": "todays-paper-may-dibosh" },
  { "new-url": "todays-paper/second-page", "old-url": "todays-paper-second-page" },
  { "new-url": "todays-paper/rokomari", "old-url": "todays-paper-rokomari" },
  { "new-url": "todays-paper/special-page", "old-url": "todays-paper-special-page" },
  { "new-url": "todays-paper/capitalcity", "old-url": "todays-paper-capitalcity" },
  { "new-url": "todays-paper/around-dhaka", "old-url": "todays-paper-around-dhaka" },
  { "new-url": "bondhushava/committee", "old-url": "bondhushava-committee" },
  { "new-url": "bondhushava/writings", "old-url": "bondhushava-writings" },
  { "new-url": "bondhushava/about", "old-url": "bondhushava-about" },
  { "new-url": "bondhushava/activities", "old-url": "bondhushava-activities" },
  { "new-url": "bondhushava/publications", "old-url": "bondhushava-publications" },
  { "new-url": "bondhushava/registration", "old-url": "bondhushava-registration" },
  { "new-url": "events/igen", "old-url": "events-igen" },
  { "new-url": "events/debate-fest", "old-url": "events-debate-fest" },
  { "new-url": "events/carnival-of-science", "old-url": "events-carnival-of-science" },
  { "new-url": "events/biyeutshob", "old-url": "events-biyeutshob" },
  { "new-url": "special-supplement/bangla-newyear", "old-url": "special-supplement-bangla-newyear" },
  { "new-url": "special-supplement/english-newyear", "old-url": "special-supplement-english-newyear" },
  { "new-url": "special-supplement/victory-day", "old-url": "special-supplement-victory-day" },
  { "new-url": "special-supplement/independence-day", "old-url": "special-supplement-independence-day" },
  {
    "new-url": "special-supplement/international-mother-language-day",
    "old-url": "special-supplement-international-mother-language-day"
  },
  { "new-url": "special-supplement/prothomalo-anniversary", "old-url": "special-supplement-prothomalo-anniversary" },
  { "new-url": "special-supplement/august-21", "old-url": "special-supplement-august-21" },
  { "new-url": "special-supplement/matholympiad", "old-url": "special-supplement-matholympiad" },
  { "new-url": "special-supplement/anniversary", "old-url": "special-supplement-anniversary" },
  { "new-url": "special-supplement/national-mourning-day", "old-url": "special-supplement-national-mourning-day" },
  { "new-url": "special-supplement/world-heart-day", "old-url": "special-supplement-world-heart-day" },
  { "new-url": "special-supplement/teachers-day", "old-url": "special-supplement-teachers-day" },
  { "new-url": "special-supplement/safe-road-day", "old-url": "special-supplement-safe-road-day" },
  { "new-url": "special-supplement/world-diabetes-day", "old-url": "special-supplement-world-diabetes-day" },
  {
    "new-url": "special-supplement/valentine-couple-contest",
    "old-url": "special-supplement-valentine-couple-contest"
  },
  { "new-url": "special-supplement/ipl-quiz", "old-url": "special-supplement-ipl-quiz" },
  { "new-url": "special-supplement/meet-the-expert", "old-url": "special-supplement-meet-the-expert" },
  { "new-url": "special-supplement/bhalobashar-onugolpo", "old-url": "special-supplement-bhalobashar-onugolpo" },
  { "new-url": "special-supplement/bangla-banan-ovijan", "old-url": "special-supplement-bangla-banan-ovijan" },
  { "new-url": "special-supplement/face-of-bangladesh", "old-url": "special-supplement-face-of-bangladesh" },
  { "new-url": "special-supplement/best-woman", "old-url": "special-supplement-best-woman" },
  { "new-url": "special-supplement/cook-for-her", "old-url": "special-supplement-cook-for-her" },
  { "new-url": "special-supplement/father-of-nation", "old-url": "special-supplement-father-of-nation" },
  { "new-url": "special-supplement/world-water-day", "old-url": "special-supplement-world-water-day" },
  { "new-url": "special-supplement/rupchanda-superchef", "old-url": "special-supplement-rupchanda-superchef" },
  { "new-url": "special-supplement/pohela-boishakh", "old-url": "special-supplement-pohela-boishakh" },
  { "new-url": "special-supplement/tomar-aloy-ujjol", "old-url": "special-supplement-tomar-aloy-ujjol" },
  { "new-url": "special-supplement/eid-bazar", "old-url": "special-supplement-eid-bazar" },
  { "new-url": "special-supplement/menstrual-hygiene-day", "old-url": "special-supplement-menstrual-hygiene-day" },
  {
    "new-url": "special-supplement/earthquake-awareness-day",
    "old-url": "special-supplement-earthquake-awareness-day"
  },
  { "new-url": "special-supplement/engenius", "old-url": "special-supplement-engenius" },
  { "new-url": "northamerica/america", "old-url": "northamerica-america" },
  { "new-url": "northamerica/canada", "old-url": "northamerica-canada" },
  { "new-url": "northamerica/northamerica-other", "old-url": "northamerica-northamerica-other" },
  { "new-url": "northamerica/available", "old-url": "northamerica-available" },
  { "new-url": "debate-fest/regional-debate", "old-url": "debate-fest-regional-debate" },
  { "new-url": "debate-fest/winner-list", "old-url": "debate-fest-winner-list" },
  { "new-url": "kishoralo/golpo", "old-url": "kishoralo-golpo" },
  { "new-url": "kishoralo/kobita", "old-url": "kishoralo-kobita" },
  { "new-url": "kishoralo/comics", "old-url": "kishoralo-comics" },
  { "new-url": "kishoralo/interview", "old-url": "kishoralo-interview" },
  { "new-url": "kishoralo/feature", "old-url": "kishoralo-feature" },
  { "new-url": "kishoralo/lifestyle", "old-url": "kishoralo-lifestyle" },
  { "new-url": "kishoralo/other", "old-url": "kishoralo-other" },
  { "new-url": "kishoralo/letter", "old-url": "kishoralo-letter" },
  { "new-url": "kishoralo/qa", "old-url": "kishoralo-qa" },
  { "new-url": "fifa-world-cup/player-selection", "old-url": "fifa-world-cup-player-selection" },
  { "new-url": "fifa-world-cup/fifa-world-cup-quiz", "old-url": "fifa-world-cup-fifa-world-cup-quiz" },
  { "new-url": "fifa-world-cup/fifa-world-cup-video", "old-url": "fifa-world-cup-fifa-world-cup-video" },
  { "new-url": "fifa-world-cup/world-cup-point-table", "old-url": "fifa-world-cup-world-cup-point-table" },
  { "new-url": "fifa-world-cup/super-selector", "old-url": "fifa-world-cup-super-selector" },
  { "new-url": "fifa-world-cup/world-cup-stadiums", "old-url": "fifa-world-cup-world-cup-stadiums" },
  { "new-url": "fifa-world-cup/fifa-world-cup-teams", "old-url": "fifa-world-cup-fifa-world-cup-teams" },
  { "new-url": "fifa-world-cup/fifa-world-cup-brazil", "old-url": "fifa-world-cup-fifa-world-cup-brazil" },
  { "new-url": "fifa-world-cup/fifa-world-cup-argentina", "old-url": "fifa-world-cup-fifa-world-cup-argentina" },
  { "new-url": "fifa-world-cup/fifa-world-cup-germany", "old-url": "fifa-world-cup-fifa-world-cup-germany" },
  { "new-url": "fifa-world-cup/fifa-world-cup-england", "old-url": "fifa-world-cup-fifa-world-cup-england" },
  { "new-url": "fifa-world-cup/fifa-world-cup-russia", "old-url": "fifa-world-cup-fifa-world-cup-russia" },
  { "new-url": "fifa-world-cup/fifa-world-cup-spain", "old-url": "fifa-world-cup-fifa-world-cup-spain" },
  { "new-url": "fifa-world-cup/fifa-world-cup-egypt", "old-url": "fifa-world-cup-fifa-world-cup-egypt" },
  { "new-url": "fifa-world-cup/fifa-world-cup-iceland", "old-url": "fifa-world-cup-fifa-world-cup-iceland" },
  { "new-url": "fifa-world-cup/fifa-world-cup-france", "old-url": "fifa-world-cup-fifa-world-cup-france" },
  { "new-url": "fifa-world-cup/fifa-world-cup-switzerland", "old-url": "fifa-world-cup-fifa-world-cup-switzerland" },
  { "new-url": "fifa-world-cup/fifa-world-cup-poland", "old-url": "fifa-world-cup-fifa-world-cup-poland" },
  { "new-url": "fifa-world-cup/fifa-world-cup-uruguay", "old-url": "fifa-world-cup-fifa-world-cup-uruguay" },
  { "new-url": "fifa-world-cup/fifa-world-cup-australia", "old-url": "fifa-world-cup-fifa-world-cup-australia" },
  { "new-url": "fifa-world-cup/fifa-world-cup-portugal", "old-url": "fifa-world-cup-fifa-world-cup-portugal" },
  { "new-url": "fifa-world-cup/fifa-world-cup-colombia", "old-url": "fifa-world-cup-fifa-world-cup-colombia" },
  { "new-url": "fifa-world-cup/fifa-world-cup-costarica", "old-url": "fifa-world-cup-fifa-world-cup-costarica" },
  { "new-url": "fifa-world-cup/fifa-world-cup-denmark", "old-url": "fifa-world-cup-fifa-world-cup-denmark" },
  { "new-url": "fifa-world-cup/fifa-world-cup-croatia", "old-url": "fifa-world-cup-fifa-world-cup-croatia" },
  { "new-url": "fifa-world-cup/fifa-world-cup-morocco", "old-url": "fifa-world-cup-fifa-world-cup-morocco" },
  { "new-url": "fifa-world-cup/fifa-world-cup-korea", "old-url": "fifa-world-cup-fifa-world-cup-korea" },
  { "new-url": "fifa-world-cup/fifa-world-cup-panama", "old-url": "fifa-world-cup-fifa-world-cup-panama" },
  { "new-url": "fifa-world-cup/fifa-world-cup-peru", "old-url": "fifa-world-cup-fifa-world-cup-peru" },
  { "new-url": "fifa-world-cup/fifa-world-cup-belgium", "old-url": "fifa-world-cup-fifa-world-cup-belgium" },
  { "new-url": "fifa-world-cup/fifa-world-cup-iran", "old-url": "fifa-world-cup-fifa-world-cup-iran" },
  { "new-url": "fifa-world-cup/fifa-world-cup-mexico", "old-url": "fifa-world-cup-fifa-world-cup-mexico" },
  { "new-url": "fifa-world-cup/fifa-world-cup-japan", "old-url": "fifa-world-cup-fifa-world-cup-japan" },
  { "new-url": "fifa-world-cup/fifa-world-cup-sweden", "old-url": "fifa-world-cup-fifa-world-cup-sweden" },
  { "new-url": "fifa-world-cup/fifa-world-cup-nigeria", "old-url": "fifa-world-cup-fifa-world-cup-nigeria" },
  { "new-url": "fifa-world-cup/fifa-world-cup-serbia", "old-url": "fifa-world-cup-fifa-world-cup-serbia" },
  { "new-url": "fifa-world-cup/fifa-world-cup-senegal", "old-url": "fifa-world-cup-fifa-world-cup-senegal" },
  { "new-url": "fifa-world-cup/fifa-world-cup-saudi-arabia", "old-url": "fifa-world-cup-fifa-world-cup-saudi-arabia" },
  { "new-url": "fifa-world-cup/fifa-world-cup-tunisia", "old-url": "fifa-world-cup-fifa-world-cup-tunisia" },
  { "new-url": "fifa-world-cup/fifa-world-cup-tech", "old-url": "fifa-world-cup-fifa-world-cup-tech" },
  { "new-url": "world-cup/fixture", "old-url": "world-cup-fixture" },
  { "new-url": "world-cup/world-cup-quiz", "old-url": "world-cup-world-cup-quiz" },
  { "new-url": "world-cup/world-cup-video", "old-url": "world-cup-world-cup-video" },
  { "new-url": "world-cup/world-cup-highlights", "old-url": "world-cup-world-cup-highlights" },
  { "new-url": "durporobash/malaysia", "old-url": "durporobash-malaysia" },
  { "new-url": "durporobash/india", "old-url": "durporobash-india" },
  { "new-url": "durporobash/europe", "old-url": "durporobash-europe" },
  { "new-url": "durporobash/africa", "old-url": "durporobash-africa" },
  { "new-url": "durporobash/america", "old-url": "durporobash-america" },
  { "new-url": "durporobash/australia", "old-url": "durporobash-australia" },
  { "new-url": "durporobash/canada", "old-url": "durporobash-canada" },
  { "new-url": "durporobash/japan", "old-url": "durporobash-japan" },
  { "new-url": "durporobash/middle-east", "old-url": "durporobash-middle-east" },
  { "new-url": "durporobash/china", "old-url": "durporobash-china" },
  { "new-url": "durporobash/singapore", "old-url": "durporobash-singapore" },
  { "new-url": "durporobash/others", "old-url": "durporobash-others" },
  { "new-url": "chakri-bakri/chakribakri-suggestion", "old-url": "chakri-bakri-chakribakri-suggestion" },
  { "new-url": "chakri-bakri/chakribakri-interview", "old-url": "chakri-bakri-chakribakri-interview" },
  { "new-url": "protichinta/politics", "old-url": "protichinta-politics" },
  { "new-url": "protichinta/society", "old-url": "protichinta-society" },
  { "new-url": "protichinta/book-discussion", "old-url": "protichinta-book-discussion" },
  { "new-url": "protichinta/family", "old-url": "protichinta-family" },
  { "new-url": "protichinta/about-us", "old-url": "protichinta-about-us" },
  { "new-url": "protichinta/contact-us", "old-url": "protichinta-contact-us" },
  { "new-url": "protichinta/subscription", "old-url": "protichinta-subscription" },
  { "new-url": "protichinta/political-economy", "old-url": "protichinta-political-economy" },
  { "new-url": "protichinta/environment", "old-url": "protichinta-environment" },
  { "new-url": "protichinta/history", "old-url": "protichinta-history" },
  { "new-url": "protichinta/interview", "old-url": "protichinta-interview" },
  { "new-url": "protichinta/evidence-and-documents", "old-url": "protichinta-evidence-and-documents" },
  { "new-url": "protichinta/philosophy", "old-url": "protichinta-philosophy" },
  { "new-url": "protichinta/nationalism", "old-url": "protichinta-nationalism" },
  { "new-url": "trust/activities", "old-url": "trust-activities" },
  { "new-url": "trust/about", "old-url": "trust-about" },
  { "new-url": "trust/details", "old-url": "trust-details" },
  { "new-url": "cartoon/basicali", "old-url": "cartoon-basicali" },
  { "new-url": "onnoalo1/cricalo-match-center", "old-url": "onnoalo1-cricalo-match-center" },
  { "new-url": "mp-award/phiredekha", "old-url": "mp-award-phiredekha" },
  { "new-url": "mp-award/news", "old-url": "mp-award-news" },
  { "new-url": "tarunno/registration", "old-url": "tarunno-registration" },
  { "new-url": "tarunno/manifesto", "old-url": "tarunno-manifesto" },
  { "new-url": "tarunno/news", "old-url": "tarunno-news" },
  { "new-url": "sports-award/award", "old-url": "sports-award-award" },
  { "new-url": "sports-award/sa-best-player", "old-url": "sports-award-sa-best-player" },
  { "new-url": "sports-award/sa-lifetime-achievement", "old-url": "sports-award-sa-lifetime-achievement" },
  { "new-url": "sports-award/sa-glittering-star", "old-url": "sports-award-sa-glittering-star" },
  { "new-url": "asia-cup-2018/asia-cup-bangladesh", "old-url": "asia-cup-2018-asia-cup-bangladesh" },
  { "new-url": "asia-cup-2018/asia-cup-india", "old-url": "asia-cup-2018-asia-cup-india" },
  { "new-url": "asia-cup-2018/asia-cup-pakistan", "old-url": "asia-cup-2018-asia-cup-pakistan" },
  { "new-url": "asia-cup-2018/asia-cup-srilanka", "old-url": "asia-cup-2018-asia-cup-srilanka" },
  { "new-url": "asia-cup-2018/asia-cup-afghanistan", "old-url": "asia-cup-2018-asia-cup-afghanistan" },
  { "new-url": "asia-cup-2018/asia-cup-hongkong", "old-url": "asia-cup-2018-asia-cup-hongkong" },
  { "new-url": "nagorik-kantho/ayojon", "old-url": "nagorik-kantho-ayojon" },
  { "new-url": "nagorik-kantho/accident", "old-url": "nagorik-kantho-accident" },
  { "new-url": "nagorik-kantho/travel", "old-url": "nagorik-kantho-travel" },
  { "new-url": "old-archive/mainPaper", "old-url": "old-archive-mainPaper" },
  { "new-url": "old-archive/mainPaperFirstPage", "old-url": "old-archive-mainPaperFirstPage" },
  { "new-url": "old-archive/mainPaperLastPage", "old-url": "old-archive-mainPaperLastPage" },
  { "new-url": "old-archive/featurePage", "old-url": "old-archive-featurePage" },
  { "new-url": "old-archive/featurenariMoncho", "old-url": "old-archive-featurenariMoncho" },
  { "new-url": "old-archive/featureAnondo", "old-url": "old-archive-featureAnondo" },
  { "new-url": "old-archive/featureGollaChut", "old-url": "old-archive-featureGollaChut" },
  { "new-url": "old-archive/mainPaperSports", "old-url": "old-archive-mainPaperSports" },
  { "new-url": "old-archive/bodhuSobha", "old-url": "old-archive-bodhuSobha" },
  { "new-url": "old-archive/bondhushova-work", "old-url": "old-archive-bondhushova-work" },
  { "new-url": "old-archive/alokito", "old-url": "old-archive-alokito" },
  { "new-url": "old-archive/others", "old-url": "old-archive-others" },
  { "new-url": "old-archive/advertisement", "old-url": "old-archive-advertisement" },
  { "new-url": "old-archive/alokitoDhakayThaki", "old-url": "old-archive-alokitoDhakayThaki" },
  { "new-url": "old-archive/alokitoChittagong", "old-url": "old-archive-alokitoChittagong" },
  { "new-url": "old-archive/featureRosalo", "old-url": "old-archive-featureRosalo" },
  { "new-url": "old-archive/prothomaPublication", "old-url": "old-archive-prothomaPublication" },
  { "new-url": "old-archive/othersCompetition", "old-url": "old-archive-othersCompetition" },
  { "new-url": "old-archive/featureHealth", "old-url": "old-archive-featureHealth" },
  { "new-url": "old-archive/featureOnnoAlo", "old-url": "old-archive-featureOnnoAlo" },
  { "new-url": "old-archive/featureProjonmoDotCom", "old-url": "old-archive-featureProjonmoDotCom" },
  { "new-url": "old-archive/featureStadium", "old-url": "old-archive-featureStadium" },
  { "new-url": "old-archive/featureNaksa", "old-url": "old-archive-featureNaksa" },
  { "new-url": "old-archive/featureChutirDine", "old-url": "old-archive-featureChutirDine" },
  { "new-url": "old-archive/featureSamoyiki", "old-url": "old-archive-featureSamoyiki" },
  { "new-url": "old-archive/businesspage", "old-url": "old-archive-businesspage" },
  { "new-url": "old-archive/mainPaperBishalBangla", "old-url": "old-archive-mainPaperBishalBangla" },
  { "new-url": "old-archive/mainPaperInternational", "old-url": "old-archive-mainPaperInternational" },
  { "new-url": "old-archive/mainPaperEducation", "old-url": "old-archive-mainPaperEducation" },
  { "new-url": "old-archive/mainPaperComputerEveryday", "old-url": "old-archive-mainPaperComputerEveryday" },
  { "new-url": "old-archive/mainPaperCapital", "old-url": "old-archive-mainPaperCapital" },
  { "new-url": "old-archive/mainPaperEntertainment", "old-url": "old-archive-mainPaperEntertainment" },
  { "new-url": "old-archive/ad-rate", "old-url": "old-archive-ad-rate" },
  { "new-url": "old-archive/ad-contact", "old-url": "old-archive-ad-contact" },
  { "new-url": "old-archive/adRules", "old-url": "old-archive-adRules" },
  { "new-url": "old-archive/alokitoSylhet", "old-url": "old-archive-alokitoSylhet" },
  { "new-url": "old-archive/alokitoNorth", "old-url": "old-archive-alokitoNorth" },
  { "new-url": "old-archive/alokitoSouth", "old-url": "old-archive-alokitoSouth" },
  { "new-url": "old-archive/bondhuSobhaComity", "old-url": "old-archive-bondhuSobhaComity" },
  { "new-url": "old-archive/bondhuSobhaMembership", "old-url": "old-archive-bondhuSobhaMembership" },
  { "new-url": "old-archive/Chalti-Bisho", "old-url": "old-archive-Chalti-Bisho" },
  { "new-url": "old-archive/newAgency", "old-url": "old-archive-newAgency" },
  { "new-url": "old-archive/sobi", "old-url": "old-archive-sobi" },
  { "new-url": "old-archive/saraDesh", "old-url": "old-archive-saraDesh" },
  { "new-url": "old-archive/editorial", "old-url": "old-archive-editorial" },
  { "new-url": "old-archive/kholaKolom", "old-url": "old-archive-kholaKolom" },
  { "new-url": "old-archive/kajerKhobor", "old-url": "old-archive-kajerKhobor" },
  { "new-url": "old-archive/abcRadio", "old-url": "old-archive-abcRadio" },
  { "new-url": "old-archive/prothomalojobs", "old-url": "old-archive-prothomalojobs" },
  { "new-url": "old-archive/prothomaloblog", "old-url": "old-archive-prothomaloblog" },
  { "new-url": "old-archive/boerJogot", "old-url": "old-archive-boerJogot" },
  { "new-url": "old-archive/latest-news", "old-url": "old-archive-latest-news" },
  { "new-url": "old-archive/desh", "old-url": "old-archive-desh" },
  { "new-url": "old-archive/business", "old-url": "old-archive-business" },
  { "new-url": "old-archive/motamot", "old-url": "old-archive-motamot" },
  { "new-url": "old-archive/binodon-bichitra", "old-url": "old-archive-binodon-bichitra" },
  { "new-url": "old-archive/science-and-technology", "old-url": "old-archive-science-and-technology" },
  { "new-url": "old-archive/profit-loss", "old-url": "old-archive-profit-loss" },
  { "new-url": "old-archive/old-circulation", "old-url": "old-archive-old-circulation" },
  { "new-url": "old-archive/bondhushova-current-version", "old-url": "old-archive-bondhushova-current-version" },
  { "new-url": "old-archive/current-users", "old-url": "old-archive-current-users" },
  { "new-url": "old-archive/Science-Jenaration", "old-url": "old-archive-Science-Jenaration" },
  { "new-url": "old-archive/Law-and-rights", "old-url": "old-archive-Law-and-rights" },
  { "new-url": "old-archive/special-category", "old-url": "old-archive-special-category" },
  { "new-url": "old-archive/budget", "old-url": "old-archive-budget" },
  { "new-url": "old-archive/borsho-suru-songkha", "old-url": "old-archive-borsho-suru-songkha" },
  { "new-url": "old-archive/sahid-dibosh", "old-url": "old-archive-sahid-dibosh" },
  { "new-url": "old-archive/sadhinota-dibosh", "old-url": "old-archive-sadhinota-dibosh" },
  { "new-url": "old-archive/noborsho-sonkha", "old-url": "old-archive-noborsho-sonkha" },
  { "new-url": "old-archive/eid-sonkha", "old-url": "old-archive-eid-sonkha" },
  { "new-url": "old-archive/portishtha-barsiki-sonkha", "old-url": "old-archive-portishtha-barsiki-sonkha" },
  { "new-url": "old-archive/bijoy-dibosh-sonkha2010", "old-url": "old-archive-bijoy-dibosh-sonkha2010" },
  { "new-url": "old-archive/crimenews", "old-url": "old-archive-crimenews" },
  { "new-url": "old-archive/palotrust", "old-url": "old-archive-palotrust" },
  { "new-url": "old-archive/acidhelpfund", "old-url": "old-archive-acidhelpfund" },
  { "new-url": "old-archive/prothom-alotrantohbil", "old-url": "old-archive-prothom-alotrantohbil" },
  { "new-url": "old-archive/antidrugcampaign", "old-url": "old-archive-antidrugcampaign" },
  { "new-url": "old-archive/nsst", "old-url": "old-archive-nsst" },
  { "new-url": "old-archive/odommomedhabi", "old-url": "old-archive-odommomedhabi" },
  { "new-url": "old-archive/phone-feed", "old-url": "old-archive-phone-feed" },
  { "new-url": "old-archive/askEditor", "old-url": "old-archive-askEditor" },
  { "new-url": "old-archive/EidSongkha", "old-url": "old-archive-EidSongkha" },
  { "new-url": "old-archive/sarodioDurgotsob", "old-url": "old-archive-sarodioDurgotsob" },
  { "new-url": "old-archive/hajjGuide", "old-url": "old-archive-hajjGuide" },
  { "new-url": "old-archive/BishesSongkha", "old-url": "old-archive-BishesSongkha" },
  { "new-url": "old-archive/comment-rules", "old-url": "old-archive-comment-rules" },
  { "new-url": "old-archive/registration-rules", "old-url": "old-archive-registration-rules" },
  { "new-url": "old-archive/protisthabarsiki", "old-url": "old-archive-protisthabarsiki" },
  { "new-url": "old-archive/health", "old-url": "old-archive-health" },
  { "new-url": "old-archive/bodlejao", "old-url": "old-archive-bodlejao" },
  { "new-url": "old-archive/bongobondhu", "old-url": "old-archive-bongobondhu" },
  { "new-url": "old-archive/tipai", "old-url": "old-archive-tipai" },
  { "new-url": "old-archive/EidUpohar09", "old-url": "old-archive-EidUpohar09" },
  { "new-url": "old-archive/gooltabledec09", "old-url": "old-archive-gooltabledec09" },
  { "new-url": "old-archive/parbottoShanti1yr", "old-url": "old-archive-parbottoShanti1yr" },
  { "new-url": "old-archive/goltable12Dec09", "old-url": "old-archive-goltable12Dec09" },
  { "new-url": "old-archive/kopenhagen13dec09", "old-url": "old-archive-kopenhagen13dec09" },
  { "new-url": "old-archive/bijoydibosh09", "old-url": "old-archive-bijoydibosh09" },
  { "new-url": "old-archive/borodin10", "old-url": "old-archive-borodin10" },
  { "new-url": "old-archive/gonitUtsob10", "old-url": "old-archive-gonitUtsob10" },
  { "new-url": "old-archive/goltable(31-12-09)", "old-url": "old-archive-goltable(31-12-09)" },
  { "new-url": "old-archive/NewYear2010", "old-url": "old-archive-NewYear2010" },
  { "new-url": "old-archive/JonomotJorip", "old-url": "old-archive-JonomotJorip" },
  { "new-url": "old-archive/goltable2010", "old-url": "old-archive-goltable2010" },
  { "new-url": "old-archive/ssc-special", "old-url": "old-archive-ssc-special" },
  { "new-url": "old-archive/sopnoniye", "old-url": "old-archive-sopnoniye" },
  { "new-url": "old-archive/DuniaKapano30Min", "old-url": "old-archive-DuniaKapano30Min" },
  { "new-url": "old-archive/21February2010", "old-url": "old-archive-21February2010" },
  { "new-url": "old-archive/BDR", "old-url": "old-archive-BDR" },
  { "new-url": "old-archive/bhasaProtijog2010", "old-url": "old-archive-bhasaProtijog2010" },
  { "new-url": "old-archive/naridibos2011", "old-url": "old-archive-naridibos2011" },
  { "new-url": "old-archive/100years", "old-url": "old-archive-100years" },
  { "new-url": "old-archive/HSC-2011", "old-url": "old-archive-HSC-2011" },
  { "new-url": "old-archive/water", "old-url": "old-archive-water" },
  { "new-url": "old-archive/sadhinotaDibosh", "old-url": "old-archive-sadhinotaDibosh" },
  { "new-url": "old-archive/goletable05082010", "old-url": "old-archive-goletable05082010" },
  { "new-url": "old-archive/boisakh1417", "old-url": "old-archive-boisakh1417" },
  { "new-url": "old-archive/mpolist", "old-url": "old-archive-mpolist" },
  { "new-url": "old-archive/bbc-janala", "old-url": "old-archive-bbc-janala" },
  { "new-url": "old-archive/olposolpo", "old-url": "old-archive-olposolpo" },
  { "new-url": "old-archive/interview", "old-url": "old-archive-interview" },
  { "new-url": "old-archive/zia", "old-url": "old-archive-zia" },
  { "new-url": "old-archive/kathopokathon", "old-url": "old-archive-kathopokathon" },
  { "new-url": "old-archive/dhaka400", "old-url": "old-archive-dhaka400" },
  { "new-url": "old-archive/EidUpohar10", "old-url": "old-archive-EidUpohar10" },
  { "new-url": "old-archive/EidBinodon", "old-url": "old-archive-EidBinodon" },
  { "new-url": "old-archive/durgapujaspecial", "old-url": "old-archive-durgapujaspecial" },
  { "new-url": "old-archive/jr-special", "old-url": "old-archive-jr-special" },
  { "new-url": "old-archive/12YearsOfProthomalo", "old-url": "old-archive-12YearsOfProthomalo" },
  { "new-url": "old-archive/40Years", "old-url": "old-archive-40Years" },
  { "new-url": "old-archive/gonotontro20years", "old-url": "old-archive-gonotontro20years" },
  { "new-url": "old-archive/bideshiderChokheBD", "old-url": "old-archive-bideshiderChokheBD" },
  { "new-url": "old-archive/Alokchitro", "old-url": "old-archive-Alokchitro" },
  { "new-url": "old-archive/testCricket", "old-url": "old-archive-testCricket" },
  { "new-url": "old-archive/gonitUtsob2011", "old-url": "old-archive-gonitUtsob2011" },
  { "new-url": "old-archive/yearEnd2010", "old-url": "old-archive-yearEnd2010" },
  { "new-url": "old-archive/newYear2011", "old-url": "old-archive-newYear2011" },
  { "new-url": "old-archive/jonomotJorip2010", "old-url": "old-archive-jonomotJorip2010" },
  { "new-url": "old-archive/ssc2011", "old-url": "old-archive-ssc2011" },
  { "new-url": "old-archive/World-Cup-Bishesh-Shonkha", "old-url": "old-archive-World-Cup-Bishesh-Shonkha" },
  { "new-url": "old-archive/21february2011", "old-url": "old-archive-21february2011" },
  { "new-url": "old-archive/BDR-Biddroh", "old-url": "old-archive-BDR-Biddroh" },
  { "new-url": "old-archive/26-march-2011", "old-url": "old-archive-26-march-2011" },
  { "new-url": "old-archive/goletable-daridro", "old-url": "old-archive-goletable-daridro" },
  { "new-url": "old-archive/Bhasha-2011", "old-url": "old-archive-Bhasha-2011" },
  { "new-url": "old-archive/tadonta-protibedon", "old-url": "old-archive-tadonta-protibedon" },
  { "new-url": "old-archive/boishakh-1418", "old-url": "old-archive-boishakh-1418" },
  { "new-url": "old-archive/yunus", "old-url": "old-archive-yunus" },
  { "new-url": "old-archive/Review-Commity", "old-url": "old-archive-Review-Commity" },
  { "new-url": "old-archive/Rabindro-Barshiki", "old-url": "old-archive-Rabindro-Barshiki" },
  { "new-url": "old-archive/goaltable", "old-url": "old-archive-goaltable" },
  { "new-url": "old-archive/Chatro-Hotta", "old-url": "old-archive-Chatro-Hotta" },
  { "new-url": "old-archive/goal-01june", "old-url": "old-archive-goal-01june" },
  { "new-url": "old-archive/goaltabil", "old-url": "old-archive-goaltabil" },
  { "new-url": "old-archive/goaltabil-05june", "old-url": "old-archive-goaltabil-05june" },
  { "new-url": "old-archive/rajuk-rehab", "old-url": "old-archive-rajuk-rehab" },
  { "new-url": "old-archive/dhakarajdhani", "old-url": "old-archive-dhakarajdhani" },
  { "new-url": "old-archive/sitmohol", "old-url": "old-archive-sitmohol" },
  { "new-url": "old-archive/Eidupohar", "old-url": "old-archive-Eidupohar" },
  { "new-url": "old-archive/prossod", "old-url": "old-archive-prossod" },
  { "new-url": "old-archive/eprothom-alo", "old-url": "old-archive-eprothom-alo" },
  { "new-url": "old-archive/blog", "old-url": "old-archive-blog" },
  { "new-url": "old-archive/tv", "old-url": "old-archive-tv" },
  { "new-url": "old-archive/hollywood", "old-url": "old-archive-hollywood" },
  { "new-url": "old-archive/bollywood", "old-url": "old-archive-bollywood" },
  { "new-url": "old-archive/movie", "old-url": "old-archive-movie" },
  { "new-url": "old-archive/songskriti-songbad", "old-url": "old-archive-songskriti-songbad" },
  { "new-url": "old-archive/songit", "old-url": "old-archive-songit" },
  { "new-url": "old-archive/monch", "old-url": "old-archive-monch" },
  { "new-url": "old-archive/nirrotto", "old-url": "old-archive-nirrotto" },
  { "new-url": "old-archive/somalochona", "old-url": "old-archive-somalochona" },
  { "new-url": "old-archive/tatokader-lekha", "old-url": "old-archive-tatokader-lekha" },
  { "new-url": "old-archive/international-music", "old-url": "old-archive-international-music" },
  { "new-url": "old-archive/home", "old-url": "old-archive-home" },
  { "new-url": "old-archive/Internet-Utbob", "old-url": "old-archive-Internet-Utbob" },
  { "new-url": "old-archive/jse-exam", "old-url": "old-archive-jse-exam" },
  { "new-url": "old-archive/goal-29oct", "old-url": "old-archive-goal-29oct" },
  { "new-url": "old-archive/Golltab-31", "old-url": "old-archive-Golltab-31" },
  { "new-url": "old-archive/13protistabarseki", "old-url": "old-archive-13protistabarseki" },
  { "new-url": "old-archive/Kurbani-Eid", "old-url": "old-archive-Kurbani-Eid" },
  { "new-url": "old-archive/Eid-binodon", "old-url": "old-archive-Eid-binodon" },
  { "new-url": "old-archive/Primary-Exam", "old-url": "old-archive-Primary-Exam" },
  { "new-url": "old-archive/gonitIskul", "old-url": "old-archive-gonitIskul" },
  { "new-url": "old-archive/Goltable-boithok(01-12-11)", "old-url": "old-archive-Goltable-boithok(01-12-11)" },
  { "new-url": "old-archive/bijoyar-40-bossor", "old-url": "old-archive-bijoyar-40-bossor" },
  { "new-url": "old-archive/goletabil-17-december-2011", "old-url": "old-archive-goletabil-17-december-2011" },
  { "new-url": "old-archive/classifieds", "old-url": "old-archive-classifieds" },
  { "new-url": "old-archive/boro-din11", "old-url": "old-archive-boro-din11" },
  { "new-url": "old-archive/borsho-sas-sonkha-2011", "old-url": "old-archive-borsho-sas-sonkha-2011" },
  { "new-url": "old-archive/new-year-feature-2012", "old-url": "old-archive-new-year-feature-2012" },
  { "new-url": "old-archive/ssc-2012", "old-url": "old-archive-ssc-2012" },
  { "new-url": "old-archive/akusar60bosor", "old-url": "old-archive-akusar60bosor" },
  { "new-url": "old-archive/maitreebandhan", "old-url": "old-archive-maitreebandhan" },
  { "new-url": "old-archive/pilkhana-3-years", "old-url": "old-archive-pilkhana-3-years" },
  { "new-url": "old-archive/International-Womens-Day-2012", "old-url": "old-archive-International-Womens-Day-2012" },
  { "new-url": "old-archive/HSC-2012", "old-url": "old-archive-HSC-2012" },
  { "new-url": "old-archive/Sadhinota-Dibos", "old-url": "old-archive-Sadhinota-Dibos" },
  { "new-url": "old-archive/Bhasa-Protijok-20-April-2012", "old-url": "old-archive-Bhasa-Protijok-20-April-2012" },
  { "new-url": "old-archive/Bhasa-Protijok-25-April-2012", "old-url": "old-archive-Bhasa-Protijok-25-April-2012" },
  { "new-url": "old-archive/main-paper-entertainment", "old-url": "old-archive-main-paper-entertainment" },
  { "new-url": "old-archive/Bhasa-Protijok-17-June-2012", "old-url": "old-archive-Bhasa-Protijok-17-June-2012" },
  { "new-url": "old-archive/2012-Gpa-5", "old-url": "old-archive-2012-Gpa-5" },
  { "new-url": "old-archive/Olympic-2012", "old-url": "old-archive-Olympic-2012" },
  { "new-url": "old-archive/Child-2012", "old-url": "old-archive-Child-2012" },
  { "new-url": "old-archive/Eid-Upohar-2012", "old-url": "old-archive-Eid-Upohar-2012" },
  { "new-url": "old-archive/Eid-Binodan-2012", "old-url": "old-archive-Eid-Binodan-2012" },
  { "new-url": "old-archive/Sabidhanik-bitorko", "old-url": "old-archive-Sabidhanik-bitorko" },
  { "new-url": "old-archive/Notuner-Janala", "old-url": "old-archive-Notuner-Janala" },
  { "new-url": "old-archive/shobar-agey-shishu", "old-url": "old-archive-shobar-agey-shishu" },
  { "new-url": "old-archive/J-S-C-parashuna-2012", "old-url": "old-archive-J-S-C-parashuna-2012" },
  { "new-url": "old-archive/Eidul-azaha-2012", "old-url": "old-archive-Eidul-azaha-2012" },
  { "new-url": "old-archive/Eidul-Azha-Eid-Binodon-2012", "old-url": "old-archive-Eidul-Azha-Eid-Binodon-2012" },
  { "new-url": "old-archive/14-protistabassik", "old-url": "old-archive-14-protistabassik" },
  { "new-url": "old-archive/bangladesh-bangladesh", "old-url": "old-archive-bangladesh-bangladesh" },
  { "new-url": "old-archive/bravo-bangladesh", "old-url": "old-archive-bravo-bangladesh" },
  { "new-url": "old-archive/16-December-2012", "old-url": "old-archive-16-December-2012" },
  { "new-url": "old-archive/Borodin-2012", "old-url": "old-archive-Borodin-2012" },
  { "new-url": "old-archive/Year-End", "old-url": "old-archive-Year-End" },
  { "new-url": "old-archive/SSC-2013", "old-url": "old-archive-SSC-2013" },
  { "new-url": "old-archive/adhuna", "old-url": "old-archive-adhuna" },
  { "new-url": "old-archive/classifieds-beta", "old-url": "old-archive-classifieds-beta" },
  { "new-url": "old-archive/dur-porobash", "old-url": "old-archive-dur-porobash" },
  { "new-url": "old-archive/beta", "old-url": "old-archive-beta" },
  { "new-url": "old-archive/21-february-2013", "old-url": "old-archive-21-february-2013" },
  { "new-url": "old-archive/Bornomela", "old-url": "old-archive-Bornomela" },
  { "new-url": "old-archive/nari-dibos-2013", "old-url": "old-archive-nari-dibos-2013" },
  { "new-url": "old-archive/HSC-Special-page-2013", "old-url": "old-archive-HSC-Special-page-2013" },
  { "new-url": "old-archive/Sadhinota-dibos-2013", "old-url": "old-archive-Sadhinota-dibos-2013" },
  { "new-url": "old-archive/Bhasa-Protijok-02-April-2013", "old-url": "old-archive-Bhasa-Protijok-02-April-2013" },
  { "new-url": "old-archive/nobo-bossho-1420", "old-url": "old-archive-nobo-bossho-1420" },
  { "new-url": "old-archive/apps", "old-url": "old-archive-apps" },
  { "new-url": "old-archive/bhasa-protijog-18-may-2013", "old-url": "old-archive-bhasa-protijog-18-may-2013" },
  { "new-url": "old-archive/currentCirculation", "old-url": "old-archive-currentCirculation" },
  { "new-url": "old-archive/2221", "old-url": "old-archive-2221" },
  { "new-url": "old-archive/amader-kotha-shono-28-may-2013", "old-url": "old-archive-amader-kotha-shono-28-may-2013" },
  { "new-url": "old-archive/basha-protijig-2-jun-2013", "old-url": "old-archive-basha-protijig-2-jun-2013" },
  { "new-url": "old-archive/amader-kothasono", "old-url": "old-archive-amader-kothasono" },
  { "new-url": "old-archive/Vasa-protijog--30-June-2013", "old-url": "old-archive-Vasa-protijog--30-June-2013" },
  { "new-url": "old-archive/amaderkhotashono-15july2013", "old-url": "old-archive-amaderkhotashono-15july2013" },
  { "new-url": "old-archive/Bhasa-08-August-2013", "old-url": "old-archive-Bhasa-08-August-2013" }
];

export const SUBSECTION_TAG_MAPPING = [
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "40",
    "tag-slug": "রাজনীতি",
    "parent-section-id": "102",
    "related-subsection-id": "105",
    "related-subsection-slug": "politics"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "42",
    "tag-slug": "অপরাধ",
    "parent-section-id": "102",
    "related-subsection-id": "108",
    "related-subsection-slug": "crime"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "45",
    "tag-slug": "আইন ও বিচার",
    "parent-section-id": "102",
    "related-subsection-id": "111",
    "related-subsection-slug": "justice"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "83",
    "tag-slug": "পরিবেশ",
    "parent-section-id": "102",
    "related-subsection-id": "114",
    "related-subsection-slug": "environment"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "44",
    "tag-slug": "জনসংখ্যা",
    "parent-section-id": "102",
    "related-subsection-id": "117",
    "related-subsection-slug": "population"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "3637",
    "tag-slug": "রাজধানী",
    "parent-section-id": "102",
    "related-subsection-id": "120",
    "related-subsection-slug": "capitalcity"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "1148",
    "tag-slug": "ঢাকা",
    "parent-section-id": "102",
    "related-subsection-id": "123",
    "related-subsection-slug": "dhaka"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "55",
    "tag-slug": "চট্টগ্রাম",
    "parent-section-id": "102",
    "related-subsection-id": "126",
    "related-subsection-slug": "chattogram"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "92",
    "tag-slug": "বরিশাল",
    "parent-section-id": "102",
    "related-subsection-id": "129",
    "related-subsection-slug": "barishal"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "50",
    "tag-slug": "রাজশাহী",
    "parent-section-id": "102",
    "related-subsection-id": "132",
    "related-subsection-slug": "rajshahi"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "90",
    "tag-slug": "খুলনা",
    "parent-section-id": "102",
    "related-subsection-id": "135",
    "related-subsection-slug": "khulna"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "47",
    "tag-slug": "রংপুর",
    "parent-section-id": "102",
    "related-subsection-id": "144",
    "related-subsection-slug": "rangpur"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "88",
    "tag-slug": "সিলেট",
    "parent-section-id": "102",
    "related-subsection-id": "147",
    "related-subsection-slug": "sylhet"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "60",
    "tag-slug": "বিবিধ",
    "parent-section-id": "102",
    "related-subsection-id": "150",
    "related-subsection-slug": "others"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "3745",
    "tag-slug": "আমেরিকা",
    "parent-section-id": "153",
    "related-subsection-id": "156",
    "related-subsection-slug": "usa"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "160",
    "tag-slug": "যুক্তরাজ্য",
    "parent-section-id": "153",
    "related-subsection-id": "159",
    "related-subsection-slug": "uk"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "59",
    "tag-slug": "ভারত",
    "parent-section-id": "153",
    "related-subsection-id": "162",
    "related-subsection-slug": "india"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "62",
    "tag-slug": "পাকিস্তান",
    "parent-section-id": "153",
    "related-subsection-id": "165",
    "related-subsection-slug": "pakistan"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "119",
    "tag-slug": "ইউরোপ",
    "parent-section-id": "153",
    "related-subsection-id": "171",
    "related-subsection-slug": "europe"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "155",
    "tag-slug": "আফ্রিকা",
    "parent-section-id": "153",
    "related-subsection-id": "174",
    "related-subsection-slug": "africa"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "61",
    "tag-slug": "আরব বিশ্ব",
    "parent-section-id": "153",
    "related-subsection-id": "177",
    "related-subsection-slug": "arab-world"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "85",
    "tag-slug": "লাতিন আমেরিকা",
    "parent-section-id": "153",
    "related-subsection-id": "180",
    "related-subsection-slug": "latin-america"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "158",
    "tag-slug": "জাতিসংঘ",
    "parent-section-id": "153",
    "related-subsection-id": "183",
    "related-subsection-slug": "united-nations"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "60",
    "tag-slug": "বিবিধ",
    "parent-section-id": "153",
    "related-subsection-id": "186",
    "related-subsection-slug": "others"
  },
  {
    "parent-section-slug": "economy",
    "tag-id": "73",
    "tag-slug": "বাণিজ্য সংবাদ",
    "parent-section-id": "189",
    "related-subsection-id": "195",
    "related-subsection-slug": "business"
  },
  {
    "parent-section-slug": "economy",
    "tag-id": "70",
    "tag-slug": "বিশ্লেষণ",
    "parent-section-id": "189",
    "related-subsection-id": "198",
    "related-subsection-slug": "analysis"
  },
  {
    "parent-section-slug": "economy",
    "tag-id": "76",
    "tag-slug": "বিদেশের খবর",
    "parent-section-id": "189",
    "related-subsection-id": "201",
    "related-subsection-slug": "international"
  },
  {
    "parent-section-slug": "economy",
    "tag-id": "77",
    "tag-slug": "মানবসম্পদ",
    "parent-section-id": "189",
    "related-subsection-id": "207",
    "related-subsection-slug": "human-resource"
  },
  {
    "parent-section-slug": "economy",
    "tag-id": "42",
    "tag-slug": "অপরাধ",
    "parent-section-id": "189",
    "related-subsection-id": "210",
    "related-subsection-slug": "crime"
  },
  {
    "parent-section-slug": "economy",
    "tag-id": "60",
    "tag-slug": "বিবিধ",
    "parent-section-id": "189",
    "related-subsection-id": "213",
    "related-subsection-slug": "others"
  },
  {
    "parent-section-slug": "sports",
    "tag-id": "138",
    "tag-slug": "দেশের ফুটবল",
    "parent-section-id": "216",
    "related-subsection-id": "219",
    "related-subsection-slug": "national-football"
  },
  {
    "parent-section-slug": "sports",
    "tag-id": "98",
    "tag-slug": "আন্তর্জাতিক ফুটবল",
    "parent-section-id": "216",
    "related-subsection-id": "222",
    "related-subsection-slug": "international-football"
  },
  {
    "parent-section-slug": "sports",
    "tag-id": "96",
    "tag-slug": "দেশের ক্রিকেট",
    "parent-section-id": "216",
    "related-subsection-id": "225",
    "related-subsection-slug": "national-cricket"
  },
  {
    "parent-section-slug": "sports",
    "tag-id": "97",
    "tag-slug": "আন্তর্জাতিক ক্রিকেট",
    "parent-section-id": "216",
    "related-subsection-id": "228",
    "related-subsection-slug": "international-cricket"
  },
  {
    "parent-section-slug": "sports",
    "tag-id": "161",
    "tag-slug": "টেনিস",
    "parent-section-id": "216",
    "related-subsection-id": "231",
    "related-subsection-slug": "tenis"
  },
  {
    "parent-section-slug": "sports",
    "tag-id": "162",
    "tag-slug": "অ্যাথলেটিকস",
    "parent-section-id": "216",
    "related-subsection-id": "234",
    "related-subsection-slug": "athletics"
  },
  {
    "parent-section-slug": "sports",
    "tag-id": "137",
    "tag-slug": "সাক্ষাৎকার",
    "parent-section-id": "216",
    "related-subsection-id": "237",
    "related-subsection-slug": "interview"
  },
  {
    "parent-section-slug": "sports",
    "tag-id": "60",
    "tag-slug": "বিবিধ",
    "parent-section-id": "216",
    "related-subsection-id": "243",
    "related-subsection-slug": "others"
  },
  {
    "parent-section-slug": "opinion",
    "tag-id": "40",
    "tag-slug": "রাজনীতি",
    "parent-section-id": "246",
    "related-subsection-id": "255",
    "related-subsection-slug": "politics"
  },
  {
    "parent-section-slug": "opinion",
    "tag-id": "105",
    "tag-slug": "অর্থনীতি",
    "parent-section-id": "246",
    "related-subsection-id": "258",
    "related-subsection-slug": "economy"
  },
  {
    "parent-section-slug": "opinion",
    "tag-id": "167",
    "tag-slug": "ধর্ম",
    "parent-section-id": "246",
    "related-subsection-id": "261",
    "related-subsection-slug": "religion"
  },
  {
    "parent-section-slug": "opinion",
    "tag-id": "58",
    "tag-slug": "আন্তর্জাতিক",
    "parent-section-id": "246",
    "related-subsection-id": "264",
    "related-subsection-slug": "international"
  },
  {
    "parent-section-slug": "opinion",
    "tag-id": "109",
    "tag-slug": "শিক্ষা",
    "parent-section-id": "246",
    "related-subsection-id": "267",
    "related-subsection-slug": "education"
  },
  {
    "parent-section-slug": "opinion",
    "tag-id": "137",
    "tag-slug": "সাক্ষাৎকার",
    "parent-section-id": "246",
    "related-subsection-id": "270",
    "related-subsection-slug": "interview"
  },
  {
    "parent-section-slug": "opinion",
    "tag-id": "168",
    "tag-slug": "বিতর্ক",
    "parent-section-id": "246",
    "related-subsection-id": "273",
    "related-subsection-slug": "debate"
  },
  {
    "parent-section-slug": "opinion",
    "tag-id": "80",
    "tag-slug": "চিঠিপত্র",
    "parent-section-id": "246",
    "related-subsection-id": "279",
    "related-subsection-slug": "letter"
  },
  {
    "parent-section-slug": "opinion",
    "tag-id": "60",
    "tag-slug": "বিবিধ",
    "parent-section-id": "246",
    "related-subsection-id": "282",
    "related-subsection-slug": "others"
  },
  {
    "parent-section-slug": "life-style",
    "tag-id": "171",
    "tag-slug": "ফ্যাশন",
    "parent-section-id": "285",
    "related-subsection-id": "288",
    "related-subsection-slug": "fashion"
  },
  {
    "parent-section-slug": "life-style",
    "tag-id": "172",
    "tag-slug": "স্টাইল",
    "parent-section-id": "285",
    "related-subsection-id": "291",
    "related-subsection-slug": "style"
  },
  {
    "parent-section-slug": "life-style",
    "tag-id": "173",
    "tag-slug": "রূপচর্চা",
    "parent-section-id": "285",
    "related-subsection-id": "294",
    "related-subsection-slug": "beautification"
  },
  {
    "parent-section-slug": "life-style",
    "tag-id": "177",
    "tag-slug": "সম্পর্ক",
    "parent-section-id": "285",
    "related-subsection-id": "300",
    "related-subsection-slug": "relation"
  },
  {
    "parent-section-slug": "life-style",
    "tag-id": "103",
    "tag-slug": "পরামর্শ",
    "parent-section-id": "285",
    "related-subsection-id": "303",
    "related-subsection-slug": "advice"
  },
  {
    "parent-section-slug": "life-style",
    "tag-id": "178",
    "tag-slug": "আমার ডাক্তার",
    "parent-section-id": "285",
    "related-subsection-id": "306",
    "related-subsection-slug": "doctor"
  },
  {
    "parent-section-slug": "life-style",
    "tag-id": "174",
    "tag-slug": "গৃহসজ্জা",
    "parent-section-id": "285",
    "related-subsection-id": "309",
    "related-subsection-slug": "home-decoration"
  },
  {
    "parent-section-slug": "life-style",
    "tag-id": "179",
    "tag-slug": "জেনে নিন",
    "parent-section-id": "285",
    "related-subsection-id": "312",
    "related-subsection-slug": "jenenin"
  },
  {
    "parent-section-slug": "life-style",
    "tag-id": "175",
    "tag-slug": "খাবারদাবার",
    "parent-section-id": "285",
    "related-subsection-id": "315",
    "related-subsection-slug": "recipe"
  },
  {
    "parent-section-slug": "life-style",
    "tag-id": "180",
    "tag-slug": "রাশিফল",
    "parent-section-id": "285",
    "related-subsection-id": "318",
    "related-subsection-slug": "horoscope"
  },
  {
    "parent-section-slug": "life-style",
    "tag-id": "60",
    "tag-slug": "বিবিধ",
    "parent-section-id": "285",
    "related-subsection-id": "321",
    "related-subsection-slug": "others"
  },
  {
    "parent-section-slug": "technology",
    "tag-id": "75",
    "tag-slug": "কম্পিউটার",
    "parent-section-id": "324",
    "related-subsection-id": "327",
    "related-subsection-slug": "computer"
  },
  {
    "parent-section-slug": "technology",
    "tag-id": "134",
    "tag-slug": "মোবাইল ফোন",
    "parent-section-id": "324",
    "related-subsection-id": "330",
    "related-subsection-slug": "mobilephone"
  },
  {
    "parent-section-slug": "technology",
    "tag-id": "182",
    "tag-slug": "অটোমোবাইল",
    "parent-section-id": "324",
    "related-subsection-id": "333",
    "related-subsection-slug": "automobile"
  },
  {
    "parent-section-slug": "technology",
    "tag-id": "187",
    "tag-slug": "গবেষণা",
    "parent-section-id": "324",
    "related-subsection-id": "336",
    "related-subsection-slug": "research"
  },
  {
    "parent-section-slug": "technology",
    "tag-id": "183",
    "tag-slug": "মহাকাশ",
    "parent-section-id": "324",
    "related-subsection-id": "339",
    "related-subsection-slug": "mohakash"
  },
  {
    "parent-section-slug": "technology",
    "tag-id": "107",
    "tag-slug": "তারকা",
    "parent-section-id": "324",
    "related-subsection-id": "342",
    "related-subsection-slug": "stars"
  },
  {
    "parent-section-slug": "technology",
    "tag-id": "185",
    "tag-slug": "গেমস",
    "parent-section-id": "324",
    "related-subsection-id": "345",
    "related-subsection-slug": "games"
  },
  {
    "parent-section-slug": "technology",
    "tag-id": "186",
    "tag-slug": "ফ্রিল্যান্সিং",
    "parent-section-id": "324",
    "related-subsection-id": "348",
    "related-subsection-slug": "freelancing"
  },
  {
    "parent-section-slug": "technology",
    "tag-id": "188",
    "tag-slug": "রিভিউ",
    "parent-section-id": "324",
    "related-subsection-id": "351",
    "related-subsection-slug": "review"
  },
  {
    "parent-section-slug": "technology",
    "tag-id": "103",
    "tag-slug": "পরামর্শ",
    "parent-section-id": "324",
    "related-subsection-id": "354",
    "related-subsection-slug": "advice"
  },
  {
    "parent-section-slug": "technology",
    "tag-id": "60",
    "tag-slug": "বিবিধ",
    "parent-section-id": "324",
    "related-subsection-id": "360",
    "related-subsection-slug": "others"
  },
  {
    "parent-section-slug": "education",
    "tag-id": "49",
    "tag-slug": "মেধাবী",
    "parent-section-id": "363",
    "related-subsection-id": "366",
    "related-subsection-slug": "meritorious"
  },
  {
    "parent-section-slug": "education",
    "tag-id": "108",
    "tag-slug": "শিক্ষাঙ্গন",
    "parent-section-id": "363",
    "related-subsection-id": "369",
    "related-subsection-slug": "institution"
  },
  {
    "parent-section-slug": "education",
    "tag-id": "154",
    "tag-slug": "জেনে রাখুন",
    "parent-section-id": "363",
    "related-subsection-id": "372",
    "related-subsection-slug": "jenerakhun"
  },
  {
    "parent-section-slug": "education",
    "tag-id": "153",
    "tag-slug": "উচ্চশিক্ষা",
    "parent-section-id": "363",
    "related-subsection-id": "375",
    "related-subsection-slug": "higher-education"
  },
  {
    "parent-section-slug": "education",
    "tag-id": "127",
    "tag-slug": "প্রাথমিক ও মাধ্যমিক শিক্ষা",
    "parent-section-id": "363",
    "related-subsection-id": "378",
    "related-subsection-slug": "primary-and-secondary-education"
  },
  {
    "parent-section-slug": "education",
    "tag-id": "130",
    "tag-slug": "উচ্চ মাধ্যমিক শিক্ষা",
    "parent-section-id": "363",
    "related-subsection-id": "381",
    "related-subsection-slug": "higher-secondary-education"
  },
  {
    "parent-section-slug": "education",
    "tag-id": "190",
    "tag-slug": "প্রস্তুতি নিন",
    "parent-section-id": "363",
    "related-subsection-id": "384",
    "related-subsection-slug": "preparation"
  },
  {
    "parent-section-slug": "education",
    "tag-id": "60",
    "tag-slug": "বিবিধ",
    "parent-section-id": "363",
    "related-subsection-id": "387",
    "related-subsection-slug": "others"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "52",
    "tag-slug": "টেলিভিশন",
    "parent-section-id": "390",
    "related-subsection-id": "393",
    "related-subsection-slug": "television"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "54",
    "tag-slug": "ঢালিউড",
    "parent-section-id": "390",
    "related-subsection-id": "396",
    "related-subsection-slug": "dhaliwood"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "65",
    "tag-slug": "সংগীত",
    "parent-section-id": "390",
    "related-subsection-id": "399",
    "related-subsection-slug": "music"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "64",
    "tag-slug": "বাংলা গান",
    "parent-section-id": "390",
    "related-subsection-id": "402",
    "related-subsection-slug": "bangla-songs"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "207",
    "tag-slug": "বিদেশের গান",
    "parent-section-id": "390",
    "related-subsection-id": "405",
    "related-subsection-slug": "international-songs"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "102",
    "tag-slug": "হলিউড",
    "parent-section-id": "390",
    "related-subsection-id": "408",
    "related-subsection-slug": "hollywood"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "56",
    "tag-slug": "বলিউড",
    "parent-section-id": "390",
    "related-subsection-id": "411",
    "related-subsection-slug": "bollywood"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "66",
    "tag-slug": "আলাপন",
    "parent-section-id": "390",
    "related-subsection-id": "414",
    "related-subsection-slug": "alapon"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "206",
    "tag-slug": "মঞ্চ",
    "parent-section-id": "390",
    "related-subsection-id": "417",
    "related-subsection-slug": "stage-performance"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "136",
    "tag-slug": "নাচ",
    "parent-section-id": "390",
    "related-subsection-id": "420",
    "related-subsection-slug": "dance"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "71",
    "tag-slug": "সমালোচনা",
    "parent-section-id": "390",
    "related-subsection-id": "423",
    "related-subsection-slug": "somalochona"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "208",
    "tag-slug": "তারকাদের লেখা",
    "parent-section-id": "390",
    "related-subsection-id": "426",
    "related-subsection-slug": "tarokader-lekha"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "60",
    "tag-slug": "বিবিধ",
    "parent-section-id": "390",
    "related-subsection-id": "429",
    "related-subsection-slug": "others"
  },
  {
    "parent-section-slug": "we-are",
    "tag-id": "157",
    "tag-slug": "তরুণ",
    "parent-section-id": "438",
    "related-subsection-id": "441",
    "related-subsection-slug": "torun"
  },
  {
    "parent-section-slug": "features",
    "tag-id": "193",
    "tag-slug": "নারীমঞ্চ",
    "parent-section-id": "474",
    "related-subsection-id": "444",
    "related-subsection-slug": "female-stage"
  },
  {
    "parent-section-slug": "we-are",
    "tag-id": "192",
    "tag-slug": "কিশোর",
    "parent-section-id": "438",
    "related-subsection-id": "447",
    "related-subsection-slug": "kishor"
  },
  {
    "parent-section-slug": "we-are",
    "tag-id": "123",
    "tag-slug": "প্রবাসী",
    "parent-section-id": "438",
    "related-subsection-id": "450",
    "related-subsection-slug": "probashi"
  },
  {
    "parent-section-slug": "we-are",
    "tag-id": "194",
    "tag-slug": "শিশু",
    "parent-section-id": "438",
    "related-subsection-id": "453",
    "related-subsection-slug": "child"
  },
  {
    "parent-section-slug": "we-are",
    "tag-id": "126",
    "tag-slug": "ব্যক্তিত্ব",
    "parent-section-id": "438",
    "related-subsection-id": "456",
    "related-subsection-slug": "personality"
  },
  {
    "parent-section-slug": "we-are",
    "tag-id": "60",
    "tag-slug": "বিবিধ",
    "parent-section-id": "438",
    "related-subsection-id": "459",
    "related-subsection-slug": "others"
  },
  {
    "parent-section-slug": "onnoalo",
    "tag-id": "159",
    "tag-slug": "কবিতা",
    "parent-section-id": "463",
    "related-subsection-id": "464",
    "related-subsection-slug": "poem"
  },
  {
    "parent-section-slug": "onnoalo",
    "tag-id": "393",
    "tag-slug": "গল্প",
    "parent-section-id": "463",
    "related-subsection-id": "465",
    "related-subsection-slug": "stories"
  },
  {
    "parent-section-slug": "onnoalo",
    "tag-id": "198",
    "tag-slug": "নিবন্ধ",
    "parent-section-id": "463",
    "related-subsection-id": "466",
    "related-subsection-slug": "treatise"
  },
  {
    "parent-section-slug": "onnoalo",
    "tag-id": "200",
    "tag-slug": "শিল্পকলা",
    "parent-section-id": "463",
    "related-subsection-id": "468",
    "related-subsection-slug": "arts"
  },
  {
    "parent-section-slug": "onnoalo",
    "tag-id": "137",
    "tag-slug": "সাক্ষাৎকার",
    "parent-section-id": "463",
    "related-subsection-id": "469",
    "related-subsection-slug": "interview"
  },
  {
    "parent-section-slug": "onnoalo",
    "tag-id": "5236",
    "tag-slug": "ভ্রমণ",
    "parent-section-id": "463",
    "related-subsection-id": "470",
    "related-subsection-slug": "travel"
  },
  {
    "parent-section-slug": "features",
    "tag-id": "211",
    "tag-slug": "নকশা",
    "parent-section-id": "474",
    "related-subsection-id": "476",
    "related-subsection-slug": "naksha"
  },
  {
    "parent-section-slug": "features",
    "tag-id": "120",
    "tag-slug": "ছুটির দিনে",
    "parent-section-id": "474",
    "related-subsection-id": "478",
    "related-subsection-slug": "holiday"
  },
  {
    "parent-section-slug": "features",
    "tag-id": "212",
    "tag-slug": "অধুনা",
    "parent-section-id": "474",
    "related-subsection-id": "479",
    "related-subsection-slug": "adhuna"
  },
  {
    "parent-section-slug": "features",
    "tag-id": "116",
    "tag-slug": "আনন্দ",
    "parent-section-id": "474",
    "related-subsection-id": "481",
    "related-subsection-slug": "ananda"
  },
  {
    "parent-section-slug": "features",
    "tag-id": "213",
    "tag-slug": "অন্য আলো",
    "parent-section-id": "474",
    "related-subsection-id": "482",
    "related-subsection-slug": "anna-alo"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "143",
    "tag-slug": "দূর পরবাসে",
    "parent-section-id": "70",
    "related-subsection-id": "483",
    "related-subsection-slug": "durporobashe"
  },
  {
    "parent-section-slug": "features",
    "tag-id": "195",
    "tag-slug": "শিল্প ও সাহিত্য",
    "parent-section-id": "474",
    "related-subsection-id": "484",
    "related-subsection-slug": "shilpo-o-sahitto"
  },
  {
    "parent-section-slug": "features",
    "tag-id": "214",
    "tag-slug": "গোল্লাছুট",
    "parent-section-id": "474",
    "related-subsection-id": "485",
    "related-subsection-slug": "gollachut"
  },
  {
    "parent-section-slug": "features",
    "tag-id": "215",
    "tag-slug": "চলতি বিশ্ব",
    "parent-section-id": "474",
    "related-subsection-id": "486",
    "related-subsection-slug": "cholti-bishow"
  },
  {
    "parent-section-slug": "features",
    "tag-id": "216",
    "tag-slug": "প্রজন্ম ডট কম",
    "parent-section-id": "474",
    "related-subsection-id": "487",
    "related-subsection-slug": "projonmo-dot-com"
  },
  {
    "parent-section-slug": "features",
    "tag-id": "219",
    "tag-slug": "সবার আগে শিশু",
    "parent-section-id": "474",
    "related-subsection-id": "491",
    "related-subsection-slug": "sabar-age-shisu"
  },
  {
    "parent-section-slug": "features",
    "tag-id": "220",
    "tag-slug": "আমার চট্টগ্রাম",
    "parent-section-id": "474",
    "related-subsection-id": "492",
    "related-subsection-slug": "alokito-chattogram"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "205",
    "tag-slug": "চলচ্চিত্র",
    "parent-section-id": "390",
    "related-subsection-id": "495",
    "related-subsection-slug": "film"
  },
  {
    "parent-section-slug": "features",
    "tag-id": "202",
    "tag-slug": "রস+আলো",
    "parent-section-id": "474",
    "related-subsection-id": "496",
    "related-subsection-slug": "roshalo"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "140",
    "tag-slug": "সরকার",
    "parent-section-id": "102",
    "related-subsection-id": "497",
    "related-subsection-slug": "government"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "234",
    "tag-slug": "দুর্ঘটনা",
    "parent-section-id": "102",
    "related-subsection-id": "499",
    "related-subsection-slug": "accident"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "235",
    "tag-slug": "সংসদ",
    "parent-section-id": "102",
    "related-subsection-id": "500",
    "related-subsection-slug": "parliament"
  },
  {
    "parent-section-slug": "onnoalo",
    "tag-id": "201",
    "tag-slug": "অনুবাদ",
    "parent-section-id": "463",
    "related-subsection-id": "501",
    "related-subsection-slug": "translation"
  },
  {
    "parent-section-slug": "life-style",
    "tag-id": "508",
    "tag-slug": "পেশা",
    "parent-section-id": "285",
    "related-subsection-id": "502",
    "related-subsection-slug": "occupation"
  },
  {
    "parent-section-slug": "technology",
    "tag-id": "181",
    "tag-slug": "খবরাখবর",
    "parent-section-id": "324",
    "related-subsection-id": "503",
    "related-subsection-slug": "news"
  },
  {
    "parent-section-slug": "special-supplement",
    "tag-id": "2794",
    "tag-slug": "বাংলা নববর্ষ সংখ্যা",
    "parent-section-id": "504",
    "related-subsection-id": "506",
    "related-subsection-slug": "bangla-newyear"
  },
  {
    "parent-section-slug": "special-supplement",
    "tag-id": "2434",
    "tag-slug": "ইংরেজি নববর্ষ সংখ্যা",
    "parent-section-id": "504",
    "related-subsection-id": "510",
    "related-subsection-slug": "english-newyear"
  },
  {
    "parent-section-slug": "special-supplement",
    "tag-id": "2383",
    "tag-slug": "বিজয় দিবস সংখ্যা",
    "parent-section-id": "504",
    "related-subsection-id": "512",
    "related-subsection-slug": "victory-day"
  },
  {
    "parent-section-slug": "special-supplement",
    "tag-id": "2779",
    "tag-slug": "স্বাধীনতা দিবস সংখ্যা",
    "parent-section-id": "504",
    "related-subsection-id": "514",
    "related-subsection-slug": "independence-day"
  },
  {
    "parent-section-slug": "special-supplement",
    "tag-id": "2623",
    "tag-slug": "অমর একুশে সংখ্যা",
    "parent-section-id": "504",
    "related-subsection-id": "516",
    "related-subsection-slug": "international-mother-language-day"
  },
  {
    "parent-section-slug": "features",
    "tag-id": "774",
    "tag-slug": "আমাদের কথা শোনো",
    "parent-section-id": "474",
    "related-subsection-id": "553",
    "related-subsection-slug": "amader-kotha-shono"
  },
  {
    "parent-section-slug": "debate-fest",
    "tag-id": "2086",
    "tag-slug": "আঞ্চলিক উৎসব",
    "parent-section-id": "558",
    "related-subsection-id": "559",
    "related-subsection-slug": "regional-debate"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "2194",
    "tag-slug": "বিডিআর বিদ্রোহ",
    "parent-section-id": "102",
    "related-subsection-id": "565",
    "related-subsection-slug": "bdr-mutiny"
  },
  {
    "parent-section-slug": "special-supplement",
    "tag-id": "2500",
    "tag-slug": "গণিত উৎসব",
    "parent-section-id": "504",
    "related-subsection-id": "592",
    "related-subsection-slug": "matholympiad"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "91",
    "tag-slug": "বিশাল বাংলা",
    "parent-section-id": "70",
    "related-subsection-id": "595",
    "related-subsection-slug": "bangla"
  },
  {
    "parent-section-slug": "fifa-world-cup",
    "tag-id": "163",
    "tag-slug": "আপনি যখন নির্বাচক",
    "parent-section-id": "682",
    "related-subsection-id": "613",
    "related-subsection-slug": "player-selection"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "41",
    "tag-slug": "প্রথম পৃষ্ঠা",
    "parent-section-id": "70",
    "related-subsection-id": "616",
    "related-subsection-slug": "first-page"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "89",
    "tag-slug": "দেশ",
    "parent-section-id": "70",
    "related-subsection-id": "619",
    "related-subsection-slug": "country"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "84",
    "tag-slug": "বিদেশ",
    "parent-section-id": "70",
    "related-subsection-id": "625",
    "related-subsection-slug": "world"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "78",
    "tag-slug": "মতামত",
    "parent-section-id": "70",
    "related-subsection-id": "628",
    "related-subsection-slug": "editorial"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "72",
    "tag-slug": "বাণিজ্য",
    "parent-section-id": "70",
    "related-subsection-id": "634",
    "related-subsection-slug": "business"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "43",
    "tag-slug": "মহানগর",
    "parent-section-id": "70",
    "related-subsection-id": "637",
    "related-subsection-slug": "capital"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "53",
    "tag-slug": "বিনোদন",
    "parent-section-id": "70",
    "related-subsection-id": "640",
    "related-subsection-slug": "entertainment"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "93",
    "tag-slug": "খেলা",
    "parent-section-id": "70",
    "related-subsection-id": "643",
    "related-subsection-slug": "sports"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "46",
    "tag-slug": "শেষের পৃষ্ঠা",
    "parent-section-id": "70",
    "related-subsection-id": "649",
    "related-subsection-slug": "last-page"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "115",
    "tag-slug": "সংস্কৃতি",
    "parent-section-id": "70",
    "related-subsection-id": "652",
    "related-subsection-slug": "culture"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "466",
    "tag-slug": "গোলটেবিল বৈঠক",
    "parent-section-id": "70",
    "related-subsection-id": "655",
    "related-subsection-slug": "roundtable"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "210",
    "tag-slug": "জীবনধারা",
    "parent-section-id": "70",
    "related-subsection-id": "658",
    "related-subsection-slug": "newhorizon"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "492",
    "tag-slug": "নির্বাচন",
    "parent-section-id": "70",
    "related-subsection-id": "661",
    "related-subsection-slug": "election"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "2449",
    "tag-slug": "নতুন বছরের পৃথিবী",
    "parent-section-id": "70",
    "related-subsection-id": "664",
    "related-subsection-slug": "future-world"
  },
  {
    "parent-section-slug": "economy",
    "tag-id": "746",
    "tag-slug": "বাজেট",
    "parent-section-id": "189",
    "related-subsection-id": "694",
    "related-subsection-slug": "budget"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "549",
    "tag-slug": "খবর",
    "parent-section-id": "70",
    "related-subsection-id": "718",
    "related-subsection-slug": "rokomari"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "3625",
    "tag-slug": "বিশেষ পাতা",
    "parent-section-id": "70",
    "related-subsection-id": "721",
    "related-subsection-slug": "special-page"
  },
  {
    "parent-section-slug": "technology",
    "tag-id": "3385",
    "tag-slug": "সিম্ফনি",
    "parent-section-id": "324",
    "related-subsection-id": "727",
    "related-subsection-slug": "symphony"
  },
  {
    "parent-section-slug": "durporobash",
    "tag-id": "59",
    "tag-slug": "ভারত",
    "parent-section-id": "736",
    "related-subsection-id": "745",
    "related-subsection-slug": "india"
  },
  {
    "parent-section-slug": "durporobash",
    "tag-id": "119",
    "tag-slug": "ইউরোপ",
    "parent-section-id": "736",
    "related-subsection-id": "748",
    "related-subsection-slug": "europe"
  },
  {
    "parent-section-slug": "durporobash",
    "tag-id": "155",
    "tag-slug": "আফ্রিকা",
    "parent-section-id": "736",
    "related-subsection-id": "751",
    "related-subsection-slug": "africa"
  },
  {
    "parent-section-slug": "durporobash",
    "tag-id": "3745",
    "tag-slug": "আমেরিকা",
    "parent-section-id": "736",
    "related-subsection-id": "754",
    "related-subsection-slug": "america"
  },
  {
    "parent-section-slug": "durporobash",
    "tag-id": "8734",
    "tag-slug": "কানাডা",
    "parent-section-id": "736",
    "related-subsection-id": "760",
    "related-subsection-slug": "canada"
  },
  {
    "parent-section-slug": "durporobash",
    "tag-id": "666",
    "tag-slug": "জাপান",
    "parent-section-id": "736",
    "related-subsection-id": "763",
    "related-subsection-slug": "japan"
  },
  {
    "parent-section-slug": "durporobash",
    "tag-id": "435",
    "tag-slug": "মধ্যপ্রাচ্য",
    "parent-section-id": "736",
    "related-subsection-id": "766",
    "related-subsection-slug": "middle-east"
  },
  {
    "parent-section-slug": "durporobash",
    "tag-id": "6896",
    "tag-slug": "সিঙ্গাপুর",
    "parent-section-id": "736",
    "related-subsection-id": "778",
    "related-subsection-slug": "singapore"
  },
  {
    "parent-section-slug": "durporobash",
    "tag-id": "60",
    "tag-slug": "বিবিধ",
    "parent-section-id": "736",
    "related-subsection-id": "784",
    "related-subsection-slug": "others"
  },
  {
    "parent-section-slug": "we-are",
    "tag-id": "3594",
    "tag-slug": "নারীর ক্ষমতা জাগায় মানবতা",
    "parent-section-id": "438",
    "related-subsection-id": "799",
    "related-subsection-slug": "international-womens-day"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "2827",
    "tag-slug": "মুক্তিযুদ্ধ",
    "parent-section-id": "102",
    "related-subsection-id": "802",
    "related-subsection-slug": "liberation-war"
  },
  {
    "parent-section-slug": "events",
    "tag-id": "3603",
    "tag-slug": "বিজ্ঞান জয়োৎসব",
    "parent-section-id": "557",
    "related-subsection-id": "805",
    "related-subsection-slug": "carnival-of-science"
  },
  {
    "parent-section-slug": "todays-paper",
    "tag-id": "3637",
    "tag-slug": "রাজধানী",
    "parent-section-id": "70",
    "related-subsection-id": "814",
    "related-subsection-slug": "capitalcity"
  },
  {
    "parent-section-slug": "northamerica",
    "tag-id": "3745",
    "tag-slug": "আমেরিকা",
    "parent-section-id": "536",
    "related-subsection-id": "826",
    "related-subsection-slug": "america"
  },
  {
    "parent-section-slug": "northamerica",
    "tag-id": "8734",
    "tag-slug": "কানাডা",
    "parent-section-id": "536",
    "related-subsection-id": "829",
    "related-subsection-slug": "canada"
  },
  {
    "parent-section-slug": "northamerica",
    "tag-id": "60",
    "tag-slug": "বিবিধ",
    "parent-section-id": "536",
    "related-subsection-id": "832",
    "related-subsection-slug": "northamerica-other"
  },
  {
    "parent-section-slug": "protichinta",
    "tag-id": "40",
    "tag-slug": "রাজনীতি",
    "parent-section-id": "835",
    "related-subsection-id": "841",
    "related-subsection-slug": "politics"
  },
  {
    "parent-section-slug": "protichinta",
    "tag-id": "105",
    "tag-slug": "অর্থনীতি",
    "parent-section-id": "835",
    "related-subsection-id": "844",
    "related-subsection-slug": "economy"
  },
  {
    "parent-section-slug": "protichinta",
    "tag-id": "1082",
    "tag-slug": "সমাজ",
    "parent-section-id": "835",
    "related-subsection-id": "847",
    "related-subsection-slug": "society"
  },
  {
    "parent-section-slug": "protichinta",
    "tag-id": "511",
    "tag-slug": "যোগাযোগ",
    "parent-section-id": "835",
    "related-subsection-id": "859",
    "related-subsection-slug": "contact-us"
  },
  {
    "parent-section-slug": "protichinta",
    "tag-id": "83",
    "tag-slug": "পরিবেশ",
    "parent-section-id": "835",
    "related-subsection-id": "891",
    "related-subsection-slug": "environment"
  },
  {
    "parent-section-slug": "protichinta",
    "tag-id": "2058",
    "tag-slug": "ইতিহাস",
    "parent-section-id": "835",
    "related-subsection-id": "896",
    "related-subsection-slug": "history"
  },
  {
    "parent-section-slug": "protichinta",
    "tag-id": "137",
    "tag-slug": "সাক্ষাৎকার",
    "parent-section-id": "835",
    "related-subsection-id": "901",
    "related-subsection-slug": "interview"
  },
  {
    "parent-section-slug": "protichinta",
    "tag-id": "58",
    "tag-slug": "আন্তর্জাতিক",
    "parent-section-id": "835",
    "related-subsection-id": "906",
    "related-subsection-slug": "international"
  },
  {
    "parent-section-slug": "kishoralo",
    "tag-id": "393",
    "tag-slug": "গল্প",
    "parent-section-id": "562",
    "related-subsection-id": "941",
    "related-subsection-slug": "golpo"
  },
  {
    "parent-section-slug": "kishoralo",
    "tag-id": "159",
    "tag-slug": "কবিতা",
    "parent-section-id": "562",
    "related-subsection-id": "946",
    "related-subsection-slug": "kobita"
  },
  {
    "parent-section-slug": "kishoralo",
    "tag-id": "137",
    "tag-slug": "সাক্ষাৎকার",
    "parent-section-id": "562",
    "related-subsection-id": "956",
    "related-subsection-slug": "interview"
  },
  {
    "parent-section-slug": "kishoralo",
    "tag-id": "93",
    "tag-slug": "খেলা",
    "parent-section-id": "562",
    "related-subsection-id": "966",
    "related-subsection-slug": "sports"
  },
  {
    "parent-section-slug": "kishoralo",
    "tag-id": "53",
    "tag-slug": "বিনোদন",
    "parent-section-id": "562",
    "related-subsection-id": "971",
    "related-subsection-slug": "entertainment"
  },
  {
    "parent-section-slug": "kishoralo",
    "tag-id": "170",
    "tag-slug": "জীবনযাপন",
    "parent-section-id": "562",
    "related-subsection-id": "976",
    "related-subsection-slug": "lifestyle"
  },
  {
    "parent-section-slug": "kishoralo",
    "tag-id": "80",
    "tag-slug": "চিঠিপত্র",
    "parent-section-id": "562",
    "related-subsection-id": "986",
    "related-subsection-slug": "letter"
  },
  {
    "parent-section-slug": "bondhushava",
    "tag-id": "511",
    "tag-slug": "যোগাযোগ",
    "parent-section-id": "488",
    "related-subsection-id": "1026",
    "related-subsection-slug": "contact"
  },
  {
    "parent-section-slug": "sports",
    "tag-id": "95",
    "tag-slug": "ক্রিকেট",
    "parent-section-id": "216",
    "related-subsection-id": "1036",
    "related-subsection-slug": "cricket"
  },
  {
    "parent-section-slug": "sports",
    "tag-id": "2374",
    "tag-slug": "ফুটবল",
    "parent-section-id": "216",
    "related-subsection-id": "1041",
    "related-subsection-slug": "football"
  },
  {
    "parent-section-slug": "sports",
    "tag-id": "4002",
    "tag-slug": "চ্যাম্পিয়নস ট্রফি",
    "parent-section-id": "216",
    "related-subsection-id": "1046",
    "related-subsection-slug": "champions"
  },
  {
    "parent-section-slug": "cartoon",
    "tag-id": "4003",
    "tag-slug": "বেসিক আলী",
    "parent-section-id": "1051",
    "related-subsection-id": "1071",
    "related-subsection-slug": "basicali"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "4076",
    "tag-slug": "বানভাসি জীবন",
    "parent-section-id": "102",
    "related-subsection-id": "1081",
    "related-subsection-slug": "flood"
  },
  {
    "parent-section-slug": "mp-award",
    "tag-id": "6786",
    "tag-slug": "ভিডিও",
    "parent-section-id": "1121",
    "related-subsection-id": "1131",
    "related-subsection-slug": "video"
  },
  {
    "parent-section-slug": "mp-award",
    "tag-id": "1944",
    "tag-slug": "ফিরে দেখা",
    "parent-section-id": "1121",
    "related-subsection-id": "1136",
    "related-subsection-slug": "phiredekha"
  },
  {
    "parent-section-slug": "special-supplement",
    "tag-id": "8622",
    "tag-slug": "নিরাপদ সড়ক দিবস",
    "parent-section-id": "504",
    "related-subsection-id": "1407",
    "related-subsection-slug": "safe-road-day"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "8734",
    "tag-slug": "কানাডা",
    "parent-section-id": "153",
    "related-subsection-id": "1411",
    "related-subsection-slug": "canada"
  },
  {
    "parent-section-slug": "sports",
    "tag-id": "8817",
    "tag-slug": "ম্যান অব দ্য ম্যাচ",
    "parent-section-id": "216",
    "related-subsection-id": "1413",
    "related-subsection-slug": "bpl-man-of-the-match"
  },
  {
    "parent-section-slug": "opinion",
    "tag-id": "1082",
    "tag-slug": "সমাজ",
    "parent-section-id": "246",
    "related-subsection-id": "1414",
    "related-subsection-slug": "society"
  },
  {
    "parent-section-slug": "special-supplement",
    "tag-id": "9140",
    "tag-slug": "মিট দ্য এক্সপার্ট",
    "parent-section-id": "504",
    "related-subsection-id": "1418",
    "related-subsection-slug": "meet-the-expert"
  },
  {
    "parent-section-slug": "special-supplement",
    "tag-id": "9072",
    "tag-slug": "ভালোবাসার অনুগল্প",
    "parent-section-id": "504",
    "related-subsection-id": "1419",
    "related-subsection-slug": "bhalobashar-onugolpo"
  },
  {
    "parent-section-slug": "special-supplement",
    "tag-id": "8962",
    "tag-slug": "বাংলা বানান অভিযান",
    "parent-section-id": "504",
    "related-subsection-id": "1420",
    "related-subsection-slug": "bangla-banan-ovijan"
  },
  {
    "parent-section-slug": "features",
    "tag-id": "3622",
    "tag-slug": "স্মার্ট সময়",
    "parent-section-id": "474",
    "related-subsection-id": "1423",
    "related-subsection-slug": "smart-somoy"
  },
  {
    "parent-section-slug": "special-supplement",
    "tag-id": "9195",
    "tag-slug": "বাংলা বর্ষবরণ",
    "parent-section-id": "504",
    "related-subsection-id": "1430",
    "related-subsection-slug": "pohela-boishakh"
  },
  {
    "parent-section-slug": "chakri-bakri",
    "tag-id": "103",
    "tag-slug": "পরামর্শ",
    "parent-section-id": "824",
    "related-subsection-id": "1431",
    "related-subsection-slug": "chakribakri-suggestion"
  },
  {
    "parent-section-slug": "chakri-bakri",
    "tag-id": "137",
    "tag-slug": "সাক্ষাৎকার",
    "parent-section-id": "824",
    "related-subsection-id": "1432",
    "related-subsection-slug": "chakribakri-interview"
  },
  {
    "parent-section-slug": "special-supplement",
    "tag-id": "9260",
    "tag-slug": "তোমার আলোয় উজ্জ্বল",
    "parent-section-id": "504",
    "related-subsection-id": "1433",
    "related-subsection-slug": "tomar-aloy-ujjol"
  },
  {
    "parent-section-slug": "special-supplement",
    "tag-id": "9285",
    "tag-slug": "ঈদ বাজার",
    "parent-section-id": "504",
    "related-subsection-id": "1434",
    "related-subsection-slug": "eid-bazar"
  },
  {
    "parent-section-slug": "nagorik-kantho",
    "tag-id": "234",
    "tag-slug": "দুর্ঘটনা",
    "parent-section-id": "1429",
    "related-subsection-id": "1440",
    "related-subsection-slug": "accident"
  },
  {
    "parent-section-slug": "nagorik-kantho",
    "tag-id": "78",
    "tag-slug": "মতামত",
    "parent-section-id": "1429",
    "related-subsection-id": "1441",
    "related-subsection-slug": "opinion"
  },
  {
    "parent-section-slug": "nagorik-kantho",
    "tag-id": "6786",
    "tag-slug": "ভিডিও",
    "parent-section-id": "1429",
    "related-subsection-id": "1443",
    "related-subsection-slug": "video"
  },
  {
    "parent-section-slug": "special-supplement",
    "tag-id": "9346",
    "tag-slug": "ভূমিকম্প সচেতনতা দিবস",
    "parent-section-id": "504",
    "related-subsection-id": "1445",
    "related-subsection-slug": "earthquake-awareness-day"
  },
  {
    "parent-section-slug": "special-supplement",
    "tag-id": "9363",
    "tag-slug": "ইন জিনিয়াস",
    "parent-section-id": "504",
    "related-subsection-id": "1446",
    "related-subsection-slug": "engenius"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "8509",
    "tag-slug": "গ্যালারি",
    "parent-section-id": "102",
    "related-subsection-id": "1447",
    "related-subsection-slug": "gallery"
  },
  {
    "parent-section-slug": "photo",
    "tag-id": "8509",
    "tag-slug": "গ্যালারি",
    "parent-section-id": "475",
    "related-subsection-id": "1448",
    "related-subsection-slug": "gallery"
  },
  {
    "parent-section-slug": "life-style",
    "tag-id": "8509",
    "tag-slug": "গ্যালারি",
    "parent-section-id": "285",
    "related-subsection-id": "1449",
    "related-subsection-slug": "gallery"
  },
  {
    "parent-section-slug": "sports",
    "tag-id": "8509",
    "tag-slug": "গ্যালারি",
    "parent-section-id": "216",
    "related-subsection-id": "1450",
    "related-subsection-slug": "gallery"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "8509",
    "tag-slug": "গ্যালারি",
    "parent-section-id": "390",
    "related-subsection-id": "1451",
    "related-subsection-slug": "gallery"
  },
  {
    "parent-section-slug": "technology",
    "tag-id": "8509",
    "tag-slug": "গ্যালারি",
    "parent-section-id": "324",
    "related-subsection-id": "1452",
    "related-subsection-slug": "gallery"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "8509",
    "tag-slug": "গ্যালারি",
    "parent-section-id": "153",
    "related-subsection-id": "1453",
    "related-subsection-slug": "gallery"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "209",
    "tag-slug": "আজকের পত্রিকা",
    "parent-section-id": "2000",
    "related-subsection-id": "2001",
    "related-subsection-slug": "mainPaper"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "193",
    "tag-slug": "নারীমঞ্চ",
    "parent-section-id": "2000",
    "related-subsection-id": "2011",
    "related-subsection-slug": "featurenariMoncho"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "116",
    "tag-slug": "আনন্দ",
    "parent-section-id": "2000",
    "related-subsection-id": "2012",
    "related-subsection-slug": "featureAnondo"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "214",
    "tag-slug": "গোল্লাছুট",
    "parent-section-id": "2000",
    "related-subsection-id": "2014",
    "related-subsection-slug": "featureGollaChut"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "93",
    "tag-slug": "খেলা",
    "parent-section-id": "2000",
    "related-subsection-id": "2015",
    "related-subsection-slug": "mainPaperSports"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "145",
    "tag-slug": "বন্ধুসভা",
    "parent-section-id": "2000",
    "related-subsection-id": "2016",
    "related-subsection-slug": "bodhuSobha"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "7666",
    "tag-slug": "বিজ্ঞাপন",
    "parent-section-id": "2000",
    "related-subsection-id": "2024",
    "related-subsection-slug": "advertisement"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "202",
    "tag-slug": "রস+আলো",
    "parent-section-id": "2000",
    "related-subsection-id": "2027",
    "related-subsection-slug": "featureRosalo"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "213",
    "tag-slug": "অন্য আলো",
    "parent-section-id": "2000",
    "related-subsection-id": "2042",
    "related-subsection-slug": "featureOnnoAlo"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "216",
    "tag-slug": "প্রজন্ম ডট কম",
    "parent-section-id": "2000",
    "related-subsection-id": "2043",
    "related-subsection-slug": "featureProjonmoDotCom"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "211",
    "tag-slug": "নকশা",
    "parent-section-id": "2000",
    "related-subsection-id": "2045",
    "related-subsection-slug": "featureNaksa"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "120",
    "tag-slug": "ছুটির দিনে",
    "parent-section-id": "2000",
    "related-subsection-id": "2046",
    "related-subsection-slug": "featureChutirDine"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "195",
    "tag-slug": "শিল্প ও সাহিত্য",
    "parent-section-id": "2000",
    "related-subsection-id": "2047",
    "related-subsection-slug": "featureSamoyiki"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "91",
    "tag-slug": "বিশাল বাংলা",
    "parent-section-id": "2000",
    "related-subsection-id": "2051",
    "related-subsection-slug": "mainPaperBishalBangla"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "128",
    "tag-slug": "পড়াশোনা",
    "parent-section-id": "2000",
    "related-subsection-id": "2053",
    "related-subsection-slug": "mainPaperEducation"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "3637",
    "tag-slug": "রাজধানী",
    "parent-section-id": "2000",
    "related-subsection-id": "2056",
    "related-subsection-slug": "mainPaperCapital"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "53",
    "tag-slug": "বিনোদন",
    "parent-section-id": "2000",
    "related-subsection-id": "2057",
    "related-subsection-slug": "mainPaperEntertainment"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "511",
    "tag-slug": "যোগাযোগ",
    "parent-section-id": "2000",
    "related-subsection-id": "2062",
    "related-subsection-slug": "ad-contact"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "215",
    "tag-slug": "চলতি বিশ্ব",
    "parent-section-id": "2000",
    "related-subsection-id": "2081",
    "related-subsection-slug": "Chalti-Bisho"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "89",
    "tag-slug": "দেশ",
    "parent-section-id": "2000",
    "related-subsection-id": "2101",
    "related-subsection-slug": "desh"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "58",
    "tag-slug": "আন্তর্জাতিক",
    "parent-section-id": "2000",
    "related-subsection-id": "2102",
    "related-subsection-slug": "international"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "72",
    "tag-slug": "বাণিজ্য",
    "parent-section-id": "2000",
    "related-subsection-id": "2103",
    "related-subsection-slug": "business"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "78",
    "tag-slug": "মতামত",
    "parent-section-id": "2000",
    "related-subsection-id": "2105",
    "related-subsection-slug": "motamot"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "67",
    "tag-slug": "বিজ্ঞান ও প্রযুক্তি",
    "parent-section-id": "2000",
    "related-subsection-id": "2107",
    "related-subsection-slug": "science-and-technology"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "145",
    "tag-slug": "বন্ধুসভা",
    "parent-section-id": "2000",
    "related-subsection-id": "2111",
    "related-subsection-slug": "bondhushova-current-version"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "619",
    "tag-slug": "আইন অধিকার",
    "parent-section-id": "2000",
    "related-subsection-id": "2114",
    "related-subsection-slug": "Law-and-rights"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "746",
    "tag-slug": "বাজেট",
    "parent-section-id": "2000",
    "related-subsection-id": "2123",
    "related-subsection-slug": "budget"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "2806",
    "tag-slug": "প্রতিষ্ঠাবার্ষিকী সংখ্যা",
    "parent-section-id": "2000",
    "related-subsection-id": "2235",
    "related-subsection-slug": "portishtha-barsiki-sonkha"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "42",
    "tag-slug": "অপরাধ",
    "parent-section-id": "2000",
    "related-subsection-id": "2247",
    "related-subsection-slug": "crimenews"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "3831",
    "tag-slug": "ত্রাণ তহবিল",
    "parent-section-id": "2000",
    "related-subsection-id": "2252",
    "related-subsection-slug": "prothom-alotrantohbil"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "7701",
    "tag-slug": "অদম্য মেধাবী",
    "parent-section-id": "2000",
    "related-subsection-id": "2255",
    "related-subsection-slug": "odommomedhabi"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "2800",
    "tag-slug": "ঈদ সংখ্যা",
    "parent-section-id": "2000",
    "related-subsection-id": "2285",
    "related-subsection-slug": "EidSongkha"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "109",
    "tag-slug": "শিক্ষা",
    "parent-section-id": "2000",
    "related-subsection-id": "2299",
    "related-subsection-slug": "education"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "6106",
    "tag-slug": "স্বাস্থ্য",
    "parent-section-id": "2000",
    "related-subsection-id": "2300",
    "related-subsection-slug": "health"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "2407",
    "tag-slug": "বড়দিন",
    "parent-section-id": "2000",
    "related-subsection-id": "2312",
    "related-subsection-slug": "borodin10"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "723",
    "tag-slug": "অল্পস্বল্প",
    "parent-section-id": "2000",
    "related-subsection-id": "2335",
    "related-subsection-slug": "olposolpo"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "137",
    "tag-slug": "সাক্ষাৎকার",
    "parent-section-id": "2000",
    "related-subsection-id": "2336",
    "related-subsection-slug": "interview"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "2194",
    "tag-slug": "বিডিআর বিদ্রোহ",
    "parent-section-id": "2000",
    "related-subsection-id": "2359",
    "related-subsection-slug": "BDR-Biddroh"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "52",
    "tag-slug": "টেলিভিশন",
    "parent-section-id": "2000",
    "related-subsection-id": "2383",
    "related-subsection-slug": "tv"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "102",
    "tag-slug": "হলিউড",
    "parent-section-id": "2000",
    "related-subsection-id": "2384",
    "related-subsection-slug": "hollywood"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "56",
    "tag-slug": "বলিউড",
    "parent-section-id": "2000",
    "related-subsection-id": "2385",
    "related-subsection-slug": "bollywood"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "54",
    "tag-slug": "ঢালিউড",
    "parent-section-id": "2000",
    "related-subsection-id": "2386",
    "related-subsection-slug": "movie"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "407",
    "tag-slug": "সংস্কৃতি সংবাদ",
    "parent-section-id": "2000",
    "related-subsection-id": "2387",
    "related-subsection-slug": "songskriti-songbad"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "65",
    "tag-slug": "সংগীত",
    "parent-section-id": "2000",
    "related-subsection-id": "2388",
    "related-subsection-slug": "songit"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "206",
    "tag-slug": "মঞ্চ",
    "parent-section-id": "2000",
    "related-subsection-id": "2389",
    "related-subsection-slug": "monch"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "71",
    "tag-slug": "সমালোচনা",
    "parent-section-id": "2000",
    "related-subsection-id": "2391",
    "related-subsection-slug": "somalochona"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "208",
    "tag-slug": "তারকাদের লেখা",
    "parent-section-id": "2000",
    "related-subsection-id": "2392",
    "related-subsection-slug": "tatokader-lekha"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "53",
    "tag-slug": "বিনোদন",
    "parent-section-id": "2000",
    "related-subsection-id": "2420",
    "related-subsection-slug": "main-paper-entertainment"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "219",
    "tag-slug": "সবার আগে শিশু",
    "parent-section-id": "2000",
    "related-subsection-id": "2424",
    "related-subsection-slug": "Child-2012"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "219",
    "tag-slug": "সবার আগে শিশু",
    "parent-section-id": "2000",
    "related-subsection-id": "2429",
    "related-subsection-slug": "shobar-agey-shishu"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "391",
    "tag-slug": "এসএসসি ২০১৩",
    "parent-section-id": "2000",
    "related-subsection-id": "2439",
    "related-subsection-slug": "SSC-2013"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "212",
    "tag-slug": "অধুনা",
    "parent-section-id": "2000",
    "related-subsection-id": "2440",
    "related-subsection-slug": "adhuna"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "143",
    "tag-slug": "দূর পরবাসে",
    "parent-section-id": "2000",
    "related-subsection-id": "2442",
    "related-subsection-slug": "dur-porobash"
  },
  {
    "parent-section-slug": "old-archive",
    "tag-id": "774",
    "tag-slug": "আমাদের কথা শোনো",
    "parent-section-id": "2000",
    "related-subsection-id": "2457",
    "related-subsection-slug": "amader-kothasono"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "4025",
    "tag-slug": "Politics",
    "parent-section-id": "561",
    "related-subsection-id": "600",
    "related-subsection-slug": "politics"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "3976",
    "tag-slug": "Crime",
    "parent-section-id": "561",
    "related-subsection-id": "601",
    "related-subsection-slug": "crime"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "4004",
    "tag-slug": "Accident",
    "parent-section-id": "561",
    "related-subsection-id": "602",
    "related-subsection-slug": "accident"
  },
  {
    "parent-section-slug": "bangladesh",
    "tag-id": "5814",
    "tag-slug": "Good Day Bangladesh",
    "parent-section-id": "561",
    "related-subsection-id": "603",
    "related-subsection-slug": "good-day-bangladesh"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "5818",
    "tag-slug": "Africa",
    "parent-section-id": "562",
    "related-subsection-id": "604",
    "related-subsection-slug": "africa"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "4217",
    "tag-slug": "Asia",
    "parent-section-id": "562",
    "related-subsection-id": "606",
    "related-subsection-slug": "asia"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "3896",
    "tag-slug": "Australia",
    "parent-section-id": "562",
    "related-subsection-id": "607",
    "related-subsection-slug": "australia"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "4190",
    "tag-slug": "China",
    "parent-section-id": "562",
    "related-subsection-id": "608",
    "related-subsection-slug": "china"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "5666",
    "tag-slug": "Europe",
    "parent-section-id": "562",
    "related-subsection-id": "609",
    "related-subsection-slug": "europe"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "4040",
    "tag-slug": "India",
    "parent-section-id": "562",
    "related-subsection-id": "610",
    "related-subsection-slug": "india"
  },
  {
    "parent-section-slug": "international",
    "tag-id": "4083",
    "tag-slug": "Middle East",
    "parent-section-id": "562",
    "related-subsection-id": "611",
    "related-subsection-slug": "middle-east"
  },
  {
    "parent-section-slug": "sports",
    "tag-id": "3972",
    "tag-slug": "Cricket",
    "parent-section-id": "564",
    "related-subsection-id": "612",
    "related-subsection-slug": "cricket"
  },
  {
    "parent-section-slug": "sports",
    "tag-id": "3973",
    "tag-slug": "Football",
    "parent-section-id": "564",
    "related-subsection-id": "613",
    "related-subsection-slug": "football"
  },
  {
    "parent-section-slug": "sports",
    "tag-id": "4161",
    "tag-slug": "Tennis",
    "parent-section-id": "564",
    "related-subsection-id": "615",
    "related-subsection-slug": "tennis"
  },
  {
    "parent-section-slug": "opinion",
    "tag-id": "5470",
    "tag-slug": "analysis",
    "parent-section-id": "567",
    "related-subsection-id": "616",
    "related-subsection-slug": "analysis"
  },
  {
    "parent-section-slug": "opinion",
    "tag-id": "5236",
    "tag-slug": "Interview",
    "parent-section-id": "567",
    "related-subsection-id": "617",
    "related-subsection-slug": "interview"
  },
  {
    "parent-section-slug": "opinion",
    "tag-id": "2990",
    "tag-slug": "Editorial",
    "parent-section-id": "567",
    "related-subsection-id": "618",
    "related-subsection-slug": "editorial"
  },
  {
    "parent-section-slug": "youth",
    "tag-id": "4009",
    "tag-slug": "Education",
    "parent-section-id": "587",
    "related-subsection-id": "621",
    "related-subsection-slug": "education"
  },
  {
    "parent-section-slug": "youth",
    "tag-id": "4721",
    "tag-slug": "Job",
    "parent-section-id": "587",
    "related-subsection-id": "623",
    "related-subsection-slug": "job"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "4494",
    "tag-slug": "Dhallywood",
    "parent-section-id": "565",
    "related-subsection-id": "624",
    "related-subsection-slug": "dhallywood"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "4032",
    "tag-slug": "Bollywood",
    "parent-section-id": "565",
    "related-subsection-id": "625",
    "related-subsection-slug": "bollywood"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "4023",
    "tag-slug": "Hollywood",
    "parent-section-id": "565",
    "related-subsection-id": "626",
    "related-subsection-slug": "hollywood"
  },
  {
    "parent-section-slug": "entertainment",
    "tag-id": "3967",
    "tag-slug": "Music",
    "parent-section-id": "565",
    "related-subsection-id": "627",
    "related-subsection-slug": "music"
  },
  {
    "parent-section-slug": "lifestyle",
    "tag-id": "5208",
    "tag-slug": "Fashion",
    "parent-section-id": "568",
    "related-subsection-id": "628",
    "related-subsection-slug": "fashion"
  },
  {
    "parent-section-slug": "lifestyle",
    "tag-id": "3984",
    "tag-slug": "Health",
    "parent-section-id": "568",
    "related-subsection-id": "629",
    "related-subsection-slug": "health"
  },
  {
    "parent-section-slug": "environment",
    "tag-id": "4253",
    "tag-slug": "Climate Change",
    "parent-section-id": "589",
    "related-subsection-id": "632",
    "related-subsection-slug": "climate-change"
  },
  {
    "parent-section-slug": "environment",
    "tag-id": "4049",
    "tag-slug": "Pollution",
    "parent-section-id": "589",
    "related-subsection-id": "633",
    "related-subsection-slug": "pollution"
  },
  {
    "parent-section-slug": "environment",
    "tag-id": "4266",
    "tag-slug": "Nature",
    "parent-section-id": "589",
    "related-subsection-id": "634",
    "related-subsection-slug": "nature"
  },
  {
    "parent-section-slug": "science-technology",
    "tag-id": "5462",
    "tag-slug": "Social Media",
    "parent-section-id": "566",
    "related-subsection-id": "635",
    "related-subsection-slug": "social-media"
  },
  {
    "parent-section-slug": "photo",
    "tag-id": "3919",
    "tag-slug": "Bangladesh",
    "parent-section-id": "581",
    "related-subsection-id": "639",
    "related-subsection-slug": "bangladesh"
  },
  {
    "parent-section-slug": "photo",
    "tag-id": "4017",
    "tag-slug": "Economy",
    "parent-section-id": "581",
    "related-subsection-id": "640",
    "related-subsection-slug": "economy"
  },
  {
    "parent-section-slug": "photo",
    "tag-id": "3925",
    "tag-slug": "Entertainment",
    "parent-section-id": "581",
    "related-subsection-id": "641",
    "related-subsection-slug": "entertainment"
  },
  {
    "parent-section-slug": "photo",
    "tag-id": "4131",
    "tag-slug": "Environment",
    "parent-section-id": "581",
    "related-subsection-id": "642",
    "related-subsection-slug": "environment"
  },
  {
    "parent-section-slug": "photo",
    "tag-id": "3921",
    "tag-slug": "International",
    "parent-section-id": "581",
    "related-subsection-id": "643",
    "related-subsection-slug": "international"
  },
  {
    "parent-section-slug": "photo",
    "tag-id": "3929",
    "tag-slug": "Lifestyle",
    "parent-section-id": "581",
    "related-subsection-id": "644",
    "related-subsection-slug": "lifestyle"
  },
  {
    "parent-section-slug": "photo",
    "tag-id": "4201",
    "tag-slug": "Opinion",
    "parent-section-id": "581",
    "related-subsection-id": "645",
    "related-subsection-slug": "opinion"
  },
  {
    "parent-section-slug": "photo",
    "tag-id": "3927",
    "tag-slug": "Science and Technology",
    "parent-section-id": "581",
    "related-subsection-id": "646",
    "related-subsection-slug": "science-and-technology"
  },
  {
    "parent-section-slug": "photo",
    "tag-id": "3923",
    "tag-slug": "Sports",
    "parent-section-id": "581",
    "related-subsection-id": "647",
    "related-subsection-slug": "sports"
  }
];
